/* AG Bundle Builder, admin tool UI. Talks to ag-bundles-script via AG_ADMIN.api().
 * List + create/edit form (component picker, reward, stacking, pre-order, live preview). */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var view = function () { return $('bnd-view'); };
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function money(n){ return '£' + (Number(n)||0).toFixed(2); }
  /* Picker labels arrive from ag-bundles-script as "Product · Variant" (middle dot since
     the 2026-09-11 sweep). Rows written before that carry the old separator, so the
     reader accepts both. Never split on '-': hyphenated titles ("4-32.5kg") would shear. */
  var PICK_SEP = ' \u00b7 ';
  var PICK_SEP_LEGACY = ' \u2014 '; // em-dash-ok: reads labels STORED before the sweep
  function splitPickLabel(t){
    t = String(t || '');
    var sep = t.indexOf(PICK_SEP) >= 0 ? PICK_SEP : (t.indexOf(PICK_SEP_LEGACY) >= 0 ? PICK_SEP_LEGACY : null);
    if (!sep) return { product: t, variant: '' };
    var i = t.indexOf(sep);
    return { product: t.slice(0, i), variant: t.slice(i + sep.length) };
  }
  function el(html){ var d=document.createElement('div'); d.innerHTML=html.trim(); return d.firstChild; }
  function seoBadge(score){ if(score==null) return '<span class="ag-bnd-seo-badge" data-s="lo">-</span>'; var s=score>=80?'hi':(score>=50?'mid':'lo'); return '<span class="ag-bnd-seo-badge" data-s="'+s+'">'+score+'%</span>'; }
  function shopUrl(productId){ var num=String(productId||'').split('/').pop(); return state.shop?('https://'+state.shop+'/admin/products/'+num):'#'; }
  // client mirror of the backend seoScore_ for live checks as the operator types
  function seoEval(f){
    var t=f.seoTitle||f.title||'', d=f.seoDescription||'', body=(f.bodyText!=null?f.bodyText:String(f.bodyHtml||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim());
    var checks=[
      {ok:t.length>0,level:'fail',msg:'SEO title set'},
      {ok:t.length>=20&&t.length<=60,level:'warn',msg:'SEO title 20–60 chars ('+t.length+')'},
      {ok:d.length>0,level:'fail',msg:'Meta description set'},
      {ok:d.length>=120&&d.length<=160,level:'warn',msg:'Meta description 120–160 chars ('+d.length+')'},
      {ok:body.length>=100,level:'warn',msg:'Product description ≥100 chars ('+body.length+')'},
      {ok:!!f.hasImage,level:'fail',msg:'Featured image set'},
      {ok:!!f.imageAlt,level:'warn',msg:'Featured image has alt text'}
    ];
    var got=0,max=0; checks.forEach(function(c){var w=c.level==='fail'?2:1;max+=w;if(c.ok)got+=w;});
    return {score:Math.round(got/max*100),checks:checks};
  }

  var state = { bundles: [], shop: '', health: null, products: null, productsLoading: false,
    section: 'bundles', cfgConfigs: null, cfgConfigsLoading: false };
  /* Configurable-bundle (Builder add-ons) form model. Holds the
     deserialised config + base-product info while editing. */
  var cfgForm = null;
  var listFilter = { term: '', status: 'all', type: 'all', reward: 'all', stock: 'all' };
  var selected = {};          // productId -> true
  var form = null;            // current create/edit model
  var previewById = {};       // id -> { title, variantTitle, price } from last preview
  var previewTotals = { subtotal:0, saving:0, bundlePrice:0 };
  var searchTimer = null, previewTimer = null;

  /* Unsaved-edit tracking + browser-back support. Opening a form pushes one
     history entry so the browser Back button returns to the list instead of
     leaving the tool; leaving a dirty form always asks first. */
  var histDepth = 0;
  function formOpen() { var v = view(); return !!(v && v.querySelector('.ag-bnd-form, .ag-bnd-cfg-form')); }
  function isDirty() { return !!((cfgForm && cfgForm.dirty) || (form && form.dirty)); }
  function clearDirty() { if (cfgForm) cfgForm.dirty = false; if (form) form.dirty = false; }
  function pushView() { try { history.pushState({ agbnd: 1 }, ''); histDepth++; } catch (_) {} }
  function leaveForm(section) {
    if (isDirty() && !confirm('Discard unsaved changes?')) return;
    clearDirty();
    if (histDepth > 0) { history.back(); return; } // popstate handler renders the list
    if (section === 'addons') bootAddons(); else boot();
  }
  window.addEventListener('popstate', function () {
    if (histDepth > 0) histDepth--;
    if (!formOpen()) return;
    if (isDirty() && !confirm('Discard unsaved changes?')) { pushView(); return; }
    clearDirty();
    if (state.section === 'addons') bootAddons(); else boot();
  });

  AG_ADMIN.onReady(function () {
    $('bnd-new').addEventListener('click', function () {
      if (isDirty() && !confirm('Discard unsaved changes?')) return;
      clearDirty();
      if (state.section === 'addons') openAddonsForm(null);
      else openForm(null);
    });
    $('bnd-tab-bundles').addEventListener('click', function () { setSection('bundles'); });
    $('bnd-tab-addons').addEventListener('click', function () { setSection('addons'); });
    $('bnd-tab-discounts').addEventListener('click', function () { setSection('discounts'); });
    $('bnd-tab-info').addEventListener('click', function () { setSection('info'); });
    boot();
  });

  /* Top-level section switch. The form view's "+ New" button changes
     label + target based on which section is active; underlying boot
     handlers re-render the matching list. */
  function setSection(s) {
    if (state.section === s) return;
    if (formOpen() && isDirty() && !confirm('Discard unsaved changes?')) return;
    clearDirty();
    state.section = s;
    $('bnd-tab-bundles').classList.toggle('on', s === 'bundles');
    $('bnd-tab-addons').classList.toggle('on', s === 'addons');
    $('bnd-tab-discounts').classList.toggle('on', s === 'discounts');
    $('bnd-tab-info').classList.toggle('on', s === 'info');
    var TITLES = { bundles: 'Bundles', addons: 'Builder add-ons', discounts: 'Discount exclusion', info: 'How it works' };
    $('bnd-section-title').textContent = TITLES[s] || 'Bundles';
    $('bnd-new').style.display = (s === 'info' || s === 'discounts') ? 'none' : '';
    $('bnd-new').textContent = s === 'addons' ? '+ Configure a base' : '+ New bundle';
    if (s === 'info') return renderBundlesInfo();
    if (s === 'discounts') return renderNoDiscount();
    if (s === 'addons') bootAddons(); else boot();
  }

  /* ── Discount exclusion panel: search ANY product, toggle its `no-discount` tag ──
     The tag is the single switch the storefront builder, the bundle discount Function,
     and native code exclusion (via the no-discount collection) all key off. */
  function renderNoDiscount() {
    view().innerHTML =
      '<div style="max-width:760px;">' +
        '<p style="font-size:13px;line-height:1.55;color:#555;margin:0 0 12px;">Search a product and toggle <strong>Exclude from discounts</strong>. This adds/removes the <code>no-discount</code> tag: the product drops out of the builder bundle saving, the storefront shows the no-code notice, and (once it is in the <code>no-discount</code> collection) customer discount codes are excluded too.</p>' +
        '<input id="nd-search" type="search" placeholder="Search products by name or SKU…" autocomplete="off" style="width:100%;padding:8px 10px;border:1px solid #ccc;border-radius:8px;font-size:13px;box-sizing:border-box;margin:0 0 12px;">' +
        '<div id="nd-results"><div class="ag-empty">Type to search products.</div></div>' +
      '</div>';
    var t;
    $('nd-search').addEventListener('input', function () {
      var term = this.value.trim();
      clearTimeout(t);
      if (!term) { $('nd-results').innerHTML = '<div class="ag-empty">Type to search products.</div>'; return; }
      t = setTimeout(function () { ndSearch(term); }, 300);
    });
  }

  function ndSearch(term) {
    $('nd-results').innerHTML = '<div class="ag-empty">Searching…</div>';
    AG_ADMIN.api('ui_nd_search', { term: term }).then(function (r) {
      var rows = r.results || [];
      if (!rows.length) { $('nd-results').innerHTML = '<div class="ag-empty">No products found.</div>'; return; }
      $('nd-results').innerHTML = rows.map(ndRow).join('');
      $('nd-results').querySelectorAll('[data-nd-toggle]').forEach(function (n) {
        n.onclick = function () { ndSet(n.dataset.ndToggle, n.dataset.ndOn === '1', n); };
      });
    }).catch(function (e) { $('nd-results').innerHTML = '<div class="ag-empty">' + esc(e.message) + '</div>'; });
  }

  function ndRow(p) {
    var on = !!p.noDiscount;
    return '<div style="display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid #eee;">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="" style="width:36px;height:36px;object-fit:cover;border-radius:6px;">' : '<span style="width:36px;height:36px;border-radius:6px;background:#f0f0f0;display:inline-block;"></span>') +
      '<span style="flex:1;font-size:13px;">' + esc(p.title) + (p.status && p.status !== 'ACTIVE' ? ' <em style="color:#999;">(' + esc(String(p.status).toLowerCase()) + ')</em>' : '') + '</span>' +
      '<button class="ag-btn' + (on ? ' ag-btn-danger' : '') + '" data-nd-toggle="' + esc(p.productId) + '" data-nd-on="' + (on ? '0' : '1') + '">' + (on ? 'Excluded ✓ (allow)' : 'Exclude from discounts') + '</button>' +
    '</div>';
  }

  function ndSet(productId, on, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    AG_ADMIN.api('ui_nd_set', { productId: productId, on: on }).then(function () {
      AG_ADMIN.toast(on ? 'Excluded from discounts' : 'Discounts allowed again');
      if (btn) {
        btn.disabled = false;
        btn.dataset.ndOn = on ? '0' : '1';
        btn.className = 'ag-btn' + (on ? ' ag-btn-danger' : '');
        btn.textContent = on ? 'Excluded ✓ (allow)' : 'Exclude from discounts';
      }
    }).catch(function (e) {
      if (btn) { btn.disabled = false; btn.textContent = on ? 'Exclude from discounts' : 'Excluded ✓ (allow)'; }
      AG_ADMIN.toast(e.message, true);
    });
  }

  function renderBundlesInfo() {
    view().innerHTML = `
      <div style="max-width:880px;font-size:13px;line-height:1.55;color:#1a1a1a;">
        <h3 style="font-size:16px;margin:0 0 8px;">What this page is</h3>
        <p>This is the staff-facing editor for Shopify <strong>native bundles</strong> and the <strong>Builder add-ons</strong> used by the Product Builder on the storefront. Replaces the old Bundles.app subscription.</p>

        <h3 style="font-size:16px;margin:24px 0 8px;">Bundles tab</h3>
        <p><strong>What a bundle is:</strong> a Shopify product that, when added to cart, automatically expands into its component products (with proportional discount). Customer pays the bundle price; the order shows each component as a separate line so dispatch + inventory see the real SKUs.</p>
        <p><strong>To create a bundle:</strong></p>
        <ol>
          <li>Click <strong>+ New bundle</strong>.</li>
          <li>Pick a parent product (the bundle product itself, make this in Shopify first).</li>
          <li>Add components. Each is a real Shopify variant + quantity.</li>
          <li>Set the bundle's customer price. The system computes the implicit discount % per component.</li>
          <li>Save. The Apps Script registers the bundle relationship via Shopify's Cart Transform API.</li>
        </ol>
        <p><strong>SEO score</strong> (the pill on each row): runs a checklist against the bundle product page (title length, meta description, image alt text, structured data). Click a bundle to see the failures and where to fix them.</p>

        <h3 style="font-size:16px;margin:24px 0 8px;">Builder add-ons tab</h3>
        <p><strong>What an add-on is:</strong> an optional extra a customer can tick on the Product Builder (e.g. a free training program, a discounted accessory). Add-ons are real Shopify variants, what this tab configures is which add-ons appear on which base product, with what discount.</p>
        <p><strong>To configure:</strong> pick a base product (a dumbbell edition, etc.), then assign one or more add-on variants with their discount. The Product Builder reads this at runtime and renders the tick boxes.</p>

        <h3 style="font-size:16px;margin:24px 0 8px;">Inventory + bundles</h3>
        <p>Because bundles use Shopify-native bundle relationships, the parent product's stock editing in Shopify admin is LOCKED. Shopify won't let you set on-hand for any variant of a bundle parent. <strong>Edit the components' stock instead</strong>, or use the AG Inventory dashboard (which knows about the bundle relationship and edits component stock).</p>

        <h3 style="font-size:16px;margin:24px 0 8px;">Troubleshooting</h3>
        <dl>
          <dt><strong>Adding the bundle to cart doesn't expand into components on the storefront</strong></dt>
          <dd>Check the Health banner at the top of this page. Both the Apps Script web app deployment and the Shopify Functions for the cart transform need to be live. If the banner says "functions not ready", re-deploy from Shopify Partners → Functions.</dd>
          <dt><strong>Discount math looks off in the order summary</strong></dt>
          <dd>The component discount is proportional to component value. If you add a £0 component (like a free training program), it can't take any of the discount. Adjust the priced components instead.</dd>
          <dt><strong>"Bundle - X" duplicate products appearing in searches</strong></dt>
          <dd>Some bundles were migrated from the old Bundles.app and left ghost duplicate products. They're being retired. Flag them and we'll archive.</dd>
        </dl>

        <h3 style="font-size:16px;margin:24px 0 8px;">Where data lives</h3>
        <p>Backend is the <code>ag-bundles-script</code> Apps Script project; data lives in a Google Sheet bound to that script. Bundle relationships are stored ALSO in Shopify (as native bundle relationships). This admin keeps the two in sync.</p>
      </div>
    `;
  }

  /* Stale-while-revalidate cache for the bootstrap payload. Two-hour
     window, bundles change rarely so a stale paint is fine while the
     fresh fetch runs in the background. */
  var BND_CACHE_KEY = 'agbnd:bootstrap-cache:v1';
  function readBootstrapCache() {
    try {
      var raw = localStorage.getItem(BND_CACHE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || !p.savedAt || Date.now() - p.savedAt > 2 * 3600 * 1000) return null;
      return p.payload || null;
    } catch (_) { return null; }
  }
  function writeBootstrapCache(payload) {
    try { localStorage.setItem(BND_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), payload: payload })); } catch (_) {}
  }
  function setBndRefreshingPip(on) {
    var existing = document.getElementById('bnd-refreshing-pip');
    if (existing) existing.remove();
    if (!on) return;
    var title = $('bnd-section-title');
    if (!title) return;
    var pip = document.createElement('span');
    pip.id = 'bnd-refreshing-pip';
    pip.style.cssText = 'margin-left:10px;font-size:11px;font-weight:400;opacity:0.7;display:inline-flex;align-items:center;gap:4px;color:#777;';
    pip.innerHTML = '<span class="ag-spinner" style="width:10px;height:10px;border-width:1.5px;display:inline-block;"></span> refreshing…';
    title.appendChild(pip);
  }

  function boot() {
    /* Paint instantly from cache if we have one, then fetch in the
       background and re-render when it lands. */
    var cached = readBootstrapCache();
    var hadCache = false;
    if (cached && cached.bundles) {
      state.bundles = cached.bundles || []; state.shop = cached.shop || ''; state.health = cached.health || {};
      renderHealth(); renderList();
      setBndRefreshingPip(true);
      hadCache = true;
    } else {
      view().innerHTML = '<div class="ag-empty">Loading bundles…</div>';
    }
    AG_ADMIN.api('ui_bootstrap', {}).then(function (b) {
      // Only cache a healthy payload. A blank shop means the backend is mid-misconfig
      // (e.g. SHOPIFY_SHOP not set yet), caching it would freeze a confusing
      // "Functions not ready on <blank>" banner that survives reloads.
      if (b && b.shop) writeBootstrapCache(b);
      state.bundles = b.bundles || []; state.shop = b.shop || ''; state.health = b.health || {};
      if (state.section === 'bundles' && !formOpen()) { renderHealth(); renderList(); }
    }).catch(function (e) {
      if (!hadCache) view().innerHTML = '<div class="ag-empty">Failed to load: ' + esc(e.message) + '</div>';
    }).then(function () {
      setBndRefreshingPip(false);
    });
  }

  function renderHealth() {
    var h = $('bnd-health');
    if (state.health && state.health.functionsReady) { h.classList.add('hidden'); return; }
    h.classList.remove('hidden');
    h.innerHTML = '⚠️ Bundle Functions not ready on <b>' + esc(state.shop) + '</b>: ' +
      esc((state.health && state.health.note) || '') + 'deploy + install the ag-bundles-app on this store first.';
  }

  /* ---------------- list ---------------- */
  function find(id) { return state.bundles.filter(function (x) { return x.productId === id; })[0]; }

  function filtered() {
    var term = listFilter.term.trim().toLowerCase();
    return state.bundles.filter(function (x) {
      // status (active/off)
      if (listFilter.status === 'active' && !x.active) return false;
      if (listFilter.status === 'off' && x.active) return false;
      // type (assembly vs discount)
      var isAssembly = x.kind === 'assembly';
      if (listFilter.type === 'assembly' && !isAssembly) return false;
      if (listFilter.type === 'discount' && isAssembly) return false;
      // reward type (pct / fixed £ / none)
      if (listFilter.reward !== 'all') {
        var rt = x.reward ? (x.reward.type === 'pct' ? 'pct' : 'fixed') : 'none';
        if (listFilter.reward !== rt) return false;
      }
      // stock (available now or not), `available` only present once backend @36+ lands
      if (listFilter.stock === 'in' && x.available === false) return false;
      if (listFilter.stock === 'out' && x.available !== false) return false;
      // text search across title, SKU, parent key and handle
      if (term) {
        var hay = (x.title + ' ' + (x.sku || '') + ' ' + (x.parentKey || '') + ' ' + (x.handle || '')).toLowerCase();
        if (hay.indexOf(term) === -1) return false;
      }
      return true;
    });
  }

  function renderList() {
    // prune selections that no longer exist
    Object.keys(selected).forEach(function (id) { if (!find(id)) delete selected[id]; });
    var total = state.bundles.length;
    if (!total) {
      view().innerHTML = '<div class="ag-bnd-empty"><div class="ag-bnd-emptyart">📦</div><h3>No bundles yet</h3><p>Click “+ New bundle” to create your first one.</p></div>';
      return;
    }
    var list = filtered();
    var activeCount = state.bundles.filter(function (x) { return x.active; }).length;

    /* Show the Type / Reward dropdowns only when the data actually varies, so
       an all-assembly / all-fixed-price store isn't cluttered with no-op menus.
       Stock + search always show. */
    var kinds = {}; var rewards = {};
    state.bundles.forEach(function (x) {
      kinds[x.kind === 'assembly' ? 'assembly' : 'discount'] = 1;
      rewards[x.reward ? (x.reward.type === 'pct' ? 'pct' : 'fixed') : 'none'] = 1;
    });
    var hasStock = state.bundles.some(function (x) { return x.available != null; });

    view().innerHTML =
      '<div class="ag-bnd-toolbar">' +
        '<div class="ag-bnd-search-wrap"><svg viewBox="0 0 20 20" class="ag-bnd-ico"><path d="M9 3.5a5.5 5.5 0 1 0 3.4 9.8l3.6 3.6 1.1-1.1-3.6-3.6A5.5 5.5 0 0 0 9 3.5Zm0 1.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"/></svg>' +
          '<input id="bnd-filter" type="text" placeholder="Search title, SKU, key or handle…" value="' + esc(listFilter.term) + '">' +
          '<button id="bnd-clear" class="ag-bnd-clearsearch' + (listFilter.term ? '' : ' hidden') + '" title="Clear search" aria-label="Clear search">×</button></div>' +
        '<div class="ag-bnd-chips">' +
          chip('all', 'All ' + total) + chip('active', 'Active ' + activeCount) + chip('off', 'Off ' + (total - activeCount)) +
        '</div>' +
        '<button class="ag-btn" id="bnd-backup" title="Download all bundle recipes as a JSON backup (recovers bundles if the app is ever removed)">⤓ Backup</button>' +
        '<button class="ag-btn" id="bnd-import" title="Bulk-create from CSV, or restore from a backup JSON">⇪ Import / Restore</button>' +
        '<button class="ag-btn" id="bnd-refreshall" title="Recompute every bundle price from current component prices">↻ Refresh prices</button>' +
      '</div>' +
      '<div class="ag-bnd-toolbar2">' +
        (Object.keys(kinds).length > 1 ? sel('type', 'Type', [['all', 'All types'], ['discount', 'Discount'], ['assembly', 'Assembly']]) : '') +
        (Object.keys(rewards).length > 1 ? sel('reward', 'Reward', [['all', 'All rewards'], ['pct', '% off'], ['fixed', '£ off'], ['none', 'No reward']]) : '') +
        (hasStock ? sel('stock', 'Stock', [['all', 'Any stock'], ['in', 'In stock'], ['out', 'Out of stock']]) : '') +
        '<span class="ag-bnd-count" id="bnd-count"></span>' +
      '</div>' +
      '<div id="bnd-bulkbar" class="ag-bnd-bulkbar hidden"></div>' +
      '<div class="ag-bnd-tablewrap"><table class="ag-bnd-table"><thead><tr>' +
        '<th class="ag-bnd-cbcol"><input type="checkbox" id="bnd-all"></th><th></th><th>Bundle</th><th>Items</th><th>Price / Saving</th><th>SEO</th><th>Status</th><th></th>' +
      '</tr></thead><tbody>' +
        (list.length ? list.map(rowHtml).join('') : '<tr><td colspan="8" class="ag-bnd-norows">No bundles match.</td></tr>') +
      '</tbody></table></div>';

    $('bnd-filter').oninput = function () {
      listFilter.term = this.value;
      var c = $('bnd-clear'); if (c) c.classList.toggle('hidden', !this.value);
      renderRowsOnly();
    };
    var clr = $('bnd-clear');
    if (clr) clr.onclick = function () { listFilter.term = ''; var i = $('bnd-filter'); if (i) { i.value = ''; i.focus(); } this.classList.add('hidden'); renderRowsOnly(); };
    ['type', 'reward', 'stock'].forEach(function (k) {
      var el = $('bnd-' + k);
      if (el) el.onchange = function () { listFilter[k] = this.value; renderRowsOnly(); };
    });
    $('bnd-refreshall').onclick = function () {
      if (!confirm('Recompute the price of ALL bundles from current component prices?')) return;
      AG_ADMIN.toast('Refreshing prices…');
      AG_ADMIN.api('ui_bulk_refresh', { productIds: [] }).then(function (r) { AG_ADMIN.toast('Refreshed ' + (r.count || 0) + ' bundle(s)'); boot(); }).catch(function (e) { AG_ADMIN.toast(e.message, true); });
    };
    $('bnd-import').onclick = openImport;
    $('bnd-backup').onclick = doBackup;
    view().querySelectorAll('[data-chip]').forEach(function (n) { n.onclick = function () { listFilter.status = n.dataset.chip; renderList(); }; });
    updateCount(list.length, total);
    wireRows();
    renderBulkBar();
  }

  function sel(key, label, opts) {
    return '<label class="ag-bnd-sel"><span>' + esc(label) + '</span><select id="bnd-' + key + '">' +
      opts.map(function (o) { return '<option value="' + o[0] + '"' + (listFilter[key] === o[0] ? ' selected' : '') + '>' + esc(o[1]) + '</option>'; }).join('') +
      '</select></label>';
  }

  function updateCount(shown, total) {
    var el = $('bnd-count'); if (!el) return;
    el.textContent = (shown === total) ? (total + ' bundle' + (total === 1 ? '' : 's')) : (shown + ' of ' + total + ' shown');
  }

  function chip(key, label) {
    return '<button class="ag-bnd-chip' + (listFilter.status === key ? ' on' : '') + '" data-chip="' + key + '">' + esc(label) + '</button>';
  }

  function rowHtml(x) {
    var assembly = x.kind === 'assembly';
    var r = assembly ? ((x.config && x.config.price != null) ? money(x.config.price) : '-')
      : (x.reward ? (x.reward.type === 'pct' ? (x.reward.value + '% off') : (money(x.reward.value) + ' off')) : '-');
    var kindTag = '<span class="ag-bnd-kind" data-k="' + (assembly ? 'a' : 'b') + '">' + (assembly ? 'Assembly' : 'Discount') + '</span>';
    return '<tr' + (selected[x.productId] ? ' class="sel"' : '') + '>' +
      '<td class="ag-bnd-cbcol"><input type="checkbox" data-sel="' + esc(x.productId) + '"' + (selected[x.productId] ? ' checked' : '') + '></td>' +
      '<td>' + (x.image ? '<img class="ag-bnd-thumb" src="' + esc(x.image) + '">' : '<span class="ag-bnd-thumb"></span>') + '</td>' +
      '<td><b>' + esc(x.title) + '</b> ' + kindTag + (x.variantCount > 1 ? ' <span class="ag-bnd-vcount" title="Edit each via the variant selector">× ' + x.variantCount + ' variants</span>' : '') + '<div class="ag-dim">' + esc(x.sku || x.parentKey || '') + '</div></td>' +
      '<td>' + x.componentCount + '</td>' +
      '<td><span class="ag-bnd-reward">' + esc(r) + '</span></td>' +
      '<td>' + seoBadge(x.seoScore) + '</td>' +
      '<td>' + (x.active ? '<span class="ag-pill ag-ok">Active</span>' : '<span class="ag-pill">Off</span>') + '</td>' +
      '<td class="ag-bnd-actions">' +
        '<button class="ag-btn" data-edit="' + esc(x.productId) + '">Edit</button>' +
        '<a class="ag-btn" href="' + esc(shopUrl(x.productId)) + '" target="_blank" rel="noopener" title="Open in Shopify">↗</a>' +
        '<button class="ag-btn" data-active="' + esc(x.productId) + '" data-on="' + (x.active ? '0' : '1') + '">' + (x.active ? 'Disable' : 'Enable') + '</button>' +
        '<button class="ag-btn" data-detach="' + esc(x.productId) + '" title="Remove the bundle but keep the product in your store">Detach</button>' +
        '<button class="ag-btn ag-btn-danger" data-del="' + esc(x.productId) + '" title="Delete (keeps the product unless you confirm otherwise)">✕</button>' +
      '</td></tr>';
  }

  function renderRowsOnly() {
    var tbody = view().querySelector('.ag-bnd-table tbody'); if (!tbody) return;
    var list = filtered();
    tbody.innerHTML = list.length ? list.map(rowHtml).join('') : '<tr><td colspan="8" class="ag-bnd-norows">No bundles match.</td></tr>';
    updateCount(list.length, state.bundles.length);
    wireRows();
  }

  function wireRows() {
    view().querySelectorAll('[data-edit]').forEach(function (n) { n.onclick = function () { openForm(find(n.dataset.edit)); }; });
    view().querySelectorAll('[data-active]').forEach(function (n) { n.onclick = function () { setActive(n.dataset.active, n.dataset.on === '1'); }; });
    view().querySelectorAll('[data-detach]').forEach(function (n) { n.onclick = function () { detachBundle(n.dataset.detach); }; });
    view().querySelectorAll('[data-del]').forEach(function (n) { n.onclick = function () { delBundle(n.dataset.del); }; });
    view().querySelectorAll('[data-sel]').forEach(function (n) { n.onchange = function () {
      if (n.checked) selected[n.dataset.sel] = true; else delete selected[n.dataset.sel];
      var tr = n.closest('tr'); if (tr) tr.classList.toggle('sel', n.checked);
      renderBulkBar();
    }; });
    var all = $('bnd-all'); if (all) all.onchange = function () {
      filtered().forEach(function (x) { if (all.checked) selected[x.productId] = true; else delete selected[x.productId]; });
      renderRowsOnly(); renderBulkBar();
    };
  }

  function renderBulkBar() {
    var bar = $('bnd-bulkbar'); if (!bar) return;
    var ids = Object.keys(selected);
    if (!ids.length) { bar.classList.add('hidden'); return; }
    bar.classList.remove('hidden');
    bar.innerHTML = '<span class="ag-bnd-selcount">' + ids.length + ' selected</span>' +
      '<button class="ag-btn" data-bulk="enable">Enable</button>' +
      '<button class="ag-btn" data-bulk="disable">Disable</button>' +
      '<button class="ag-btn" data-bulk="refresh">Refresh prices</button>' +
      '<button class="ag-btn ag-btn-danger" data-bulk="delete">Delete</button>' +
      '<button class="ag-btn ag-bnd-clear" data-bulk="clear">Clear</button>';
    bar.querySelectorAll('[data-bulk]').forEach(function (n) { n.onclick = function () { bulk(n.dataset.bulk); }; });
  }

  function bulk(action) {
    var ids = Object.keys(selected);
    if (!ids.length) return;
    if (action === 'clear') { selected = {}; renderList(); return; }
    var hard = false;
    if (action === 'delete') {
      // Safe default first, then opt in to actually deleting the products.
      if (!confirm('Remove ' + ids.length + ' bundle(s)?\n\nThe products stay in your store. Only their bundle setup is removed.')) return;
      hard = confirm('Also delete these ' + ids.length + ' product(s) from your store entirely?\n\nOK = permanently delete the products.\nCancel = keep the products (recommended), just remove the bundles.');
    }
    var call = action === 'delete' ? AG_ADMIN.api('ui_bulk_delete', { productIds: ids, deleteProduct: hard })
      : action === 'refresh' ? AG_ADMIN.api('ui_bulk_refresh', { productIds: ids })
      : AG_ADMIN.api('ui_bulk_active', { productIds: ids, active: action === 'enable' });
    AG_ADMIN.toast('Working on ' + ids.length + '…');
    call.then(function (r) { selected = {}; AG_ADMIN.toast('Done (' + (r.count || 0) + ')'); boot(); })
        .catch(function (e) { AG_ADMIN.toast(e.message, true); });
  }

  function setActive(productId, on) {
    AG_ADMIN.api('ui_set_active', { productId: productId, active: on }).then(function () {
      AG_ADMIN.toast(on ? 'Enabled' : 'Disabled'); boot();
    }).catch(function (e) { AG_ADMIN.toast(e.message, true); });
  }
  function detachBundle(productId) {
    // Row-level shortcut for the safe action: remove the bundle, keep the product. One confirm only.
    if (!confirm('Remove this bundle but keep the product?\n\nThe product stays in your store as a normal product. Only its bundle setup is removed.')) return;
    AG_ADMIN.api('ui_delete_bundle', { productId: productId, deleteProduct: false }).then(function () {
      AG_ADMIN.toast('Bundle removed, product kept'); boot();
    }).catch(function (e) { AG_ADMIN.toast(e.message, true); });
  }
  function delBundle(productId) {
    // Default is the SAFE action: remove the bundle setup but keep the product live in the store.
    if (!confirm('Remove this bundle?\n\nThe product stays in your store as a normal product. Only its bundle setup is removed.')) return;
    // Deleting the actual product is opt-in: it needs a second, explicit yes.
    var hard = confirm('Also delete the product from your store entirely?\n\nOK = permanently delete the product.\nCancel = keep the product (recommended), just remove the bundle.');
    AG_ADMIN.api('ui_delete_bundle', { productId: productId, deleteProduct: hard }).then(function () {
      AG_ADMIN.toast(hard ? 'Product deleted' : 'Bundle removed, product kept'); boot();
    }).catch(function (e) { AG_ADMIN.toast(e.message, true); });
  }

  /* ---------------- form ---------------- */
  function openForm(bundle) {
    if (!formOpen()) pushView();
    form = {
      productId: bundle ? bundle.productId : null,
      variantId: bundle ? bundle.variantId : null,
      variantCount: bundle ? (bundle.variantCount || 1) : 1,
      // isEdit = opened from an existing bundle. parentMode (assembly, new bundles only):
      // 'new' = builder creates the parent product; 'existing' = convert a product you already have.
      isEdit: !!bundle, parentMode: 'new',
      variants: null, seo: null
    };
    applyConfig_((bundle && bundle.config) || {}, bundle ? bundle.title : '');
    previewById = {};
    renderForm();
    refreshPreview();
    ensureProducts();
    if (form.productId) { loadSeo(); if (form.variantCount > 1) loadVariants(); }
  }

  // Load a config object (one variant's recipe) into the form fields.
  function applyConfig_(cfg, title) {
    cfg = cfg || {}; var rw = cfg.reward || {};
    form.title = title || form.title || '';
    form.parentKey = cfg.parentKey || '';
    form.components = (cfg.components || []).map(function (c) { return { id: c.id, qty: c.qty || 1, role: c.role || 'component' }; });
    form.rewardMode = rw.type === 'fixed' ? 'fixed' : 'pct';
    form.rewardValue = rw.value != null ? rw.value : 10;
    form.label = cfg.label || 'Bundle saving';
    form.codes = (cfg.stacking && cfg.stacking.codes) || 'none';
    form.combinesWithShipping = !(cfg.stacking && cfg.stacking.combinesWithShipping === false);
    form.allowPreorder = !!(cfg.availability && cfg.availability.allowPreorderComponents);
    form.active = cfg.active !== false;
    form.kind = cfg.kind === 'assembly' ? 'assembly' : 'bundle';
    form.price = cfg.price != null ? cfg.price : '';
  }

  // Multi-variant product → fetch every variant's recipe so the operator can edit each.
  function loadVariants() {
    AG_ADMIN.api('ui_bundle_variants', { productId: form.productId }).then(function (r) {
      form.variants = r.variants || [];
      form.optionName = r.optionName || '';
      renderForm(); refreshPreview(); // re-render even single-variant: the variant tools need the list + option name
    }).catch(function () {});
  }

  /* Variant tools, add / remove / image / reorder / option rename + weight & barcode.
     All admin-locked on bundle parents, so these are their only home. */
  function wireVariantTools() {
    var or = $('f-opt-rename'); if (or) or.onclick = function () {
      var name = prompt('New option name (currently "' + (form.optionName || '') + '"):', form.optionName || '');
      if (name == null || !name.trim() || name.trim() === form.optionName) return;
      AG_ADMIN.api('ui_rename_option', { productId: form.productId, name: name.trim() }).then(function () {
        AG_ADMIN.toast('Option renamed'); form.optionName = name.trim(); renderForm();
      }).catch(function (e) { AG_ADMIN.toast('Rename failed: ' + e.message, true); });
    };

    var va = $('f-variant-add'); if (va) va.onclick = function () {
      var name = prompt('Name for the new variant (e.g. "50kg"):', '');
      if (name == null || !name.trim()) return;
      var price = prompt('Price for "' + name.trim() + '" (adjustable later):', '');
      if (price == null) return;
      va.disabled = true; va.textContent = 'Adding…';
      AG_ADMIN.api('ui_variant_add', { productId: form.productId, name: name.trim(), price: price }).then(function (r) {
        AG_ADMIN.toast('Variant added, now give it components and Save');
        AG_ADMIN.api('ui_bundle_variants', { productId: form.productId }).then(function (rv) {
          form.variants = rv.variants || []; form.optionName = rv.optionName || form.optionName;
          if (r.variantId) switchVariant(r.variantId); else renderForm();
        });
      }).catch(function (e) { AG_ADMIN.toast('Add failed: ' + e.message, true); va.disabled = false; va.textContent = '＋ Add variant'; });
    };

    var vd = $('f-variant-remove'); if (vd) vd.onclick = function () {
      var cur = (form.variants || []).filter(function (x) { return x.variantId === form.variantId; })[0];
      if (!confirm('Delete variant "' + ((cur && cur.title) || 'this variant') + '"? Its recipe disappears with it.')) return;
      vd.disabled = true;
      AG_ADMIN.api('ui_variant_remove', { productId: form.productId, variantId: form.variantId }).then(function () {
        AG_ADMIN.toast('Variant removed');
        AG_ADMIN.api('ui_bundle_variants', { productId: form.productId }).then(function (rv) {
          form.variants = rv.variants || [];
          if (form.variants.length) switchVariant(form.variants[0].variantId); else boot();
        });
      }).catch(function (e) { AG_ADMIN.toast('Remove failed: ' + e.message, true); vd.disabled = false; });
    };

    /* B288: un-bundle ONE size (the backend keeps its price and turns stock tracking on). Its
       stock is then its own number, so the result says what Shopify holds and where to set it. */
    var vu = $('f-variant-unbundle'); if (vu) vu.onclick = function () {
      var cur = (form.variants || []).filter(function (x) { return x.variantId === form.variantId; })[0];
      var label = (cur && cur.title) || 'this size';
      if (!confirm('Un-bundle "' + label + '"?\n\nIt stops using its boxes and becomes a normal product with its own stock. Its price stays the same. The other sizes are not touched.')) return;
      vu.disabled = true; vu.textContent = 'Un-bundling…';
      AG_ADMIN.api('ui_bundle_remove_size', { variantId: form.variantId }).then(function (r) {
        var msg = '"' + label + '" is un-bundled. Price: £' + r.price + '.\n\n';
        msg += r.warning ? r.warning : ('Shopify now tracks its own stock and shows ' + r.available + '. Set the real number on the Stock tab now.');
        alert(msg);
        AG_ADMIN.api('ui_bundle_variants', { productId: form.productId }).then(function (rv) {
          form.variants = rv.variants || [];
          if (form.variants.length) switchVariant(form.variants[0].variantId); else boot();
        });
      }).catch(function (e) { AG_ADMIN.toast('Un-bundle failed: ' + e.message, true); vu.disabled = false; vu.textContent = 'Un-bundle this size'; });
    };

    var vi = $('f-variant-image'); if (vi) vi.onclick = function () {
      vi.disabled = true;
      AG_ADMIN.api('ui_media_list', { productId: form.productId }).then(function (r) {
        vi.disabled = false;
        var media = r.media || [];
        if (!media.length) { AG_ADMIN.toast('No images on this product yet. Add them in Shopify first (product images are not locked)', true); return; }
        var ov = document.createElement('div'); ov.className = 'ag-bnd-modal-overlay';
        ov.innerHTML = '<div class="ag-bnd-modal"><h3>Pick this variant’s image</h3><div class="ag-bnd-mediagrid">' +
          media.map(function (m) { return '<img class="ag-bnd-mediapick" data-mid="' + esc(m.mediaId) + '" src="' + esc(m.url || '') + '" title="' + esc(m.alt) + '">'; }).join('') +
          '</div><div class="ag-bnd-modal-foot"><button class="ag-btn" id="f-media-cancel">Cancel</button></div></div>';
        document.body.appendChild(ov);
        ov.querySelector('#f-media-cancel').onclick = function () { ov.remove(); };
        ov.querySelectorAll('[data-mid]').forEach(function (n) { n.onclick = function () {
          AG_ADMIN.api('ui_variant_image', { productId: form.productId, variantId: form.variantId, mediaId: n.dataset.mid }).then(function () {
            AG_ADMIN.toast('Variant image set'); ov.remove();
          }).catch(function (e) { AG_ADMIN.toast('Failed: ' + e.message, true); });
        }; });
      }).catch(function (e) { AG_ADMIN.toast('Could not load images: ' + e.message, true); vi.disabled = false; });
    };

    var vro = $('f-variant-reorder'); if (vro) vro.onclick = function () {
      var order = (form.variants || []).map(function (v) { return { id: v.variantId, title: v.title || v.sku || '(default)' }; });
      var ov = document.createElement('div'); ov.className = 'ag-bnd-modal-overlay';
      function paint() {
        ov.innerHTML = '<div class="ag-bnd-modal"><h3>Reorder variants</h3><div class="ag-bnd-reorderlist">' +
          order.map(function (o, i) { return '<div class="ag-bnd-rorow"><span>' + (i + 1) + '. ' + esc(o.title) + '</span><span>' +
            '<button class="ag-btn" data-up="' + i + '"' + (i === 0 ? ' disabled' : '') + '>↑</button>' +
            '<button class="ag-btn" data-down="' + i + '"' + (i === order.length - 1 ? ' disabled' : '') + '>↓</button></span></div>'; }).join('') +
          '</div><div class="ag-bnd-modal-foot"><button class="ag-btn" id="f-ro-cancel">Cancel</button><button class="ag-btn ag-btn-primary" id="f-ro-save">Save order</button></div></div>';
        ov.querySelector('#f-ro-cancel').onclick = function () { ov.remove(); };
        ov.querySelectorAll('[data-up]').forEach(function (n) { n.onclick = function () { var i = +n.dataset.up; var t = order[i - 1]; order[i - 1] = order[i]; order[i] = t; paint(); }; });
        ov.querySelectorAll('[data-down]').forEach(function (n) { n.onclick = function () { var i = +n.dataset.down; var t = order[i + 1]; order[i + 1] = order[i]; order[i] = t; paint(); }; });
        ov.querySelector('#f-ro-save').onclick = function () {
          AG_ADMIN.api('ui_variants_reorder', { productId: form.productId, variantIds: order.map(function (o) { return o.id; }) }).then(function () {
            AG_ADMIN.toast('Order saved'); ov.remove(); loadVariants();
          }).catch(function (e) { AG_ADMIN.toast('Reorder failed: ' + e.message, true); });
        };
      }
      paint(); document.body.appendChild(ov);
    };

    // weight + barcode: load current values, save on demand. Save stays DISABLED until the
    // current values land, clicking early would overwrite them with blanks.
    if (form.isEdit && form.variantId && $('f-weight')) {
      var sm = $('f-shipmeta-save'); if (sm) sm.disabled = true;
      AG_ADMIN.api('ui_variant_meta_get', { variantId: form.variantId }).then(function (m) {
        var w = $('f-weight'), b = $('f-barcode');
        if (w) { w.value = m.weightKg || ''; w.placeholder = 'e.g. 41.5'; }
        if (b) { b.value = m.barcode || ''; b.placeholder = 'e.g. 5060000000000'; }
        if (sm) sm.disabled = false;
      }).catch(function () { AG_ADMIN.toast('Could not load weight/barcode. Save disabled', true); });
      if (sm) sm.onclick = function () {
        sm.disabled = true; sm.textContent = 'Saving…';
        AG_ADMIN.api('ui_variant_meta_set', { productId: form.productId, variantId: form.variantId, barcode: $('f-barcode').value, weightKg: $('f-weight').value }).then(function () {
          AG_ADMIN.toast('Weight/barcode saved'); sm.disabled = false; sm.textContent = 'Save weight/barcode';
        }).catch(function (e) { AG_ADMIN.toast('Failed: ' + e.message, true); sm.disabled = false; sm.textContent = 'Save weight/barcode'; });
      };
    }
  }
  function switchVariant(variantId) {
    var v = (form.variants || []).filter(function (x) { return x.variantId === variantId; })[0];
    if (!v) return;
    form.variantId = variantId;
    var fresh = !v.config || !Object.keys(v.config).length; // just-added variant, no recipe yet
    var prevKind = form.kind, prevLabel = form.label;
    applyConfig_(v.config, form.title); // same product title; load THIS variant's recipe
    if (fresh) { form.kind = prevKind; form.label = prevLabel; } // inherit the bundle's mode, applyConfig_({}) would silently reset an assembly to "Discount bundle"
    previewById = {};
    renderForm(); refreshPreview();
  }

  function loadSeo() {
    AG_ADMIN.api('ui_seo_get', { productId: form.productId }).then(function (r) {
      form.seo = r.seo || {}; renderSeoSection();
    }).catch(function () { form.seo = {}; renderSeoSection(); });
  }

  // Product list for the picker. Stale-while-revalidate: paint instantly from a short-lived
  // session cache, but ALWAYS refresh in the background so newly-created products (and payload
  // shape changes) appear without anyone clearing the cache. The cache KEY is versioned, bump
  // PRODUCTS_CACHE_KEY whenever the ui_products payload changes shape so old caches self-drop.
  var PRODUCTS_CACHE_KEY = 'agBndProducts:v3'; // v3 = entries now carry productTitle (convert prefill)
  var PRODUCTS_TTL = 10 * 60 * 1000;
  function ensureProducts() {
    if (!state.products) {
      try {
        var raw = sessionStorage.getItem(PRODUCTS_CACHE_KEY);
        if (raw) { var p = JSON.parse(raw); if (p && p.savedAt && (Date.now() - p.savedAt) < PRODUCTS_TTL && Array.isArray(p.products)) state.products = p.products; }
      } catch (e) {}
    }
    if (state.productsLoading) return;
    state.productsLoading = true;
    AG_ADMIN.api('ui_products', {}).then(function (r) {
      if (r && Array.isArray(r.products)) {
        state.products = r.products;
        try { sessionStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), products: state.products })); } catch (e) {}
      }
    }).catch(function () { /* search box shows a hint */ }).then(function () {
      state.productsLoading = false;
      // If a picker is open with a term typed, re-run its filter now that fresh data is in.
      ['f-search', 'f-parent-search'].forEach(function (id) { var n = $(id); if (n && n.value) n.dispatchEvent(new Event('input')); });
    });
  }

  function renderForm() {
    var f = form;
    var assembly = f.kind === 'assembly';
    var modeBtn = function (k, label, sub) {
      return '<button type="button" class="ag-bnd-mode' + (f.kind === k ? ' on' : '') + '" data-mode="' + k + '"><b>' + label + '</b><span>' + sub + '</span></button>';
    };
    // Discount-bundle-only block (reward + stacking). Hidden in assembly mode.
    var discountBlock =
      '<div class="ag-bnd-row">' +
        '<label class="ag-fld"><span>Reward</span><select id="f-rmode">' +
          '<option value="pct"' + (f.rewardMode === 'pct' ? ' selected' : '') + '>% off</option>' +
          '<option value="fixed"' + (f.rewardMode === 'fixed' ? ' selected' : '') + '>£ off</option>' +
          '<option value="price"' + (f.rewardMode === 'price' ? ' selected' : '') + '>Set bundle price (£)</option>' +
        '</select></label>' +
        '<label class="ag-fld"><span id="f-rval-lbl">' + (f.rewardMode === 'price' ? 'Bundle price' : 'Value') + '</span><input id="f-rval" type="number" step="0.01" min="0" value="' + esc(f.rewardValue) + '"></label>' +
        '<label class="ag-fld"><span>Discount label</span><input id="f-label" type="text" value="' + esc(f.label) + '"></label>' +
      '</div>' +
      '<div class="ag-bnd-row">' +
        '<label class="ag-fld"><span>Discount codes</span><select id="f-codes">' +
          '<option value="none"' + (f.codes === 'none' ? ' selected' : '') + '>Block codes on this bundle</option>' +
          '<option value="any"' + (f.codes === 'any' ? ' selected' : '') + '>Allow codes</option>' +
        '</select></label>' +
        '<label class="ag-chk"><input id="f-ship" type="checkbox"' + (f.combinesWithShipping ? ' checked' : '') + '> Allow free-shipping to stack</label>' +
        '<label class="ag-chk"><input id="f-preorder" type="checkbox"' + (f.allowPreorder ? ' checked' : '') + '> Allow pre-order components</label>' +
      '</div>';
    // Assembly-only block (the product's own price).
    var assemblyBlock =
      '<div class="ag-bnd-row">' +
        '<label class="ag-fld"><span>Bundle price (£), what the customer pays</span><input id="f-price" type="number" step="0.01" min="0" value="' + esc(f.price) + '" placeholder="e.g. 199.00"></label>' +
      '</div>';
    // Assembly-only (new bundles): choose to CREATE a new parent product, or CONVERT an existing
    // product into the kit (attach the boxes to it). Hidden when editing an existing bundle.
    var pmodeBtn = function (k, label, sub) {
      return '<button type="button" class="ag-bnd-mode' + (f.parentMode === k ? ' on' : '') + '" data-pmode="' + k + '"><b>' + label + '</b><span>' + sub + '</span></button>';
    };
    var parentBlock = (assembly && !f.isEdit) ?
      '<div class="ag-bnd-parentsel">' +
        '<span class="ag-fld-cap">Parent product</span>' +
        '<div class="ag-bnd-modes">' +
          pmodeBtn('new', 'Create new product', 'Builder makes it from the name below') +
          pmodeBtn('existing', 'Convert existing product', 'Turn a product you already have into this kit') +
        '</div>' +
        (f.parentMode === 'existing' ? (
          f.productId
            ? '<div class="ag-bnd-parentpick">Converting <b>' + esc(f.title) + '</b> <button type="button" class="ag-btn" id="f-parent-clear">change</button></div>'
            : '<div class="ag-bnd-search"><input id="f-parent-search" type="text" placeholder="Search the product to convert…" autocomplete="off"><div id="f-parent-results" class="ag-bnd-results hidden"></div></div>'
        ) : '') +
      '</div>' : '';

    // Variant selector, multi-variant bundle products carry a separate recipe per variant.
    var variantSel = (f.variants && f.variants.length > 1) ?
      '<div class="ag-bnd-varsel"><label class="ag-fld"><span>Editing variant (this product has ' + f.variants.length + ', each its own recipe)</span><select id="f-variant">' +
        f.variants.map(function (v) { return '<option value="' + esc(v.variantId) + '"' + (v.variantId === f.variantId ? ' selected' : '') + '>' + esc(v.title || v.sku || '(default)') + '</option>'; }).join('') +
      '</select></label>' +
      (f.isEdit ? '<button type="button" class="ag-btn" id="f-variant-rename" title="Rename this variant. Shopify locks variant edits on bundle products, so this renames it via the API">✎ Rename variant</button>' : '') +
      '</div>' : '';

    // Variant tools, every one of these is LOCKED in Shopify admin on bundle parents, so the
    // Builder is the only place they can happen. Add works on single-variant bundles too.
    var multiVar = f.variants && f.variants.length > 1;
    var variantTools = f.isEdit ?
      '<div class="ag-bnd-vartools">' +
        (multiVar && f.optionName ? '<span class="ag-dim">Option: <b>' + esc(f.optionName) + '</b> <button type="button" class="ag-btn" id="f-opt-rename" title="Rename the option itself (e.g. Weight → Size)">✎</button></span>' : '') +
        '<button type="button" class="ag-btn" id="f-variant-add" title="Add a new variant to this bundle. Give it components and Save">＋ Add variant</button>' +
        (multiVar ? '<button type="button" class="ag-btn" id="f-variant-image" title="Choose which product image this variant shows">🖼 Image</button>' : '') +
        (multiVar ? '<button type="button" class="ag-btn" id="f-variant-reorder" title="Change the order variants appear in">⇅ Reorder</button>' : '') +
        (multiVar ? '<button type="button" class="ag-btn" id="f-variant-unbundle" title="Make this size a normal product with its own stock. Keeps its price; the other sizes stay bundles">Un-bundle this size</button>' : '') +
        (multiVar ? '<button type="button" class="ag-btn ag-btn-danger" id="f-variant-remove" title="Delete this variant and its recipe">✕ Remove</button>' : '') +
      '</div>' : '';

    view().innerHTML =
      '<div class="ag-bnd-form">' +
        '<div class="ag-bnd-formhead"><h3>' + (f.productId ? 'Edit bundle' : 'New bundle') + '</h3>' +
          '<button class="ag-btn" id="bnd-cancel">← Back</button></div>' +

        '<div class="ag-bnd-modes">' +
          modeBtn('bundle', 'Discount bundle', 'Sell products together with a saving') +
          modeBtn('assembly', 'Assembly / kit', 'One product made of £0 stock boxes') +
        '</div>' +

        parentBlock +
        variantSel +
        variantTools +
        '<label class="ag-fld"><span>Bundle name</span><input id="f-title" type="text" value="' + esc(f.title) + '" placeholder="e.g. Chrome Dumbbell Kit"></label>' +
        '<label class="ag-fld"><span>Bundle SKU / key</span><input id="f-key" type="text" value="' + esc(f.parentKey) + '" placeholder="auto if blank, always forced to start BUNDLE-"></label>' +
        (f.isEdit ? '<div class="ag-bnd-shipmeta">' +
          '<label class="ag-fld"><span>Shipping weight (kg)</span><input id="f-weight" type="number" step="0.01" min="0" placeholder="loading…"></label>' +
          '<label class="ag-fld"><span>Barcode (GTIN/EAN)</span><input id="f-barcode" type="text" placeholder="loading…"></label>' +
          '<button type="button" class="ag-btn" id="f-shipmeta-save" title="Weight and barcode live in the locked variant panel, saved separately via the API">Save weight/barcode</button>' +
        '</div>' : '') +

        '<div class="ag-fld"><span>' + (assembly ? 'Boxes / components (stock comes from these)' : 'Components') + '</span>' +
          '<div class="ag-bnd-search"><input id="f-search" type="text" placeholder="' + (assembly ? 'Search box SKUs to add…' : 'Search products to add…') + '" autocomplete="off"><div id="f-results" class="ag-bnd-results hidden"></div></div>' +
          '<div id="f-components"></div>' +
        '</div>' +

        (assembly ? assemblyBlock : discountBlock) +

        '<div class="ag-bnd-row"><label class="ag-chk"><input id="f-active" type="checkbox"' + (f.active ? ' checked' : '') + '> Active</label></div>' +

        '<div id="f-preview" class="ag-bnd-preview"></div>' +
        '<div id="f-seo" class="ag-bnd-seo"></div>' +
        '<div class="ag-bnd-formfoot"><button class="ag-btn ag-btn-primary" id="bnd-save">Save bundle</button></div>' +
      '</div>';

    $('bnd-cancel').onclick = function () { leaveForm('bundles'); };
    $('bnd-save').onclick = save;
    var fv = $('f-variant'); if (fv) fv.onchange = function () { switchVariant(this.value); };
    var vr = $('f-variant-rename'); if (vr) vr.onclick = function () {
      var cur = (form.variants || []).filter(function (x) { return x.variantId === form.variantId; })[0];
      var curName = cur ? (cur.title || '') : '';
      var name = prompt('New name for this variant (e.g. "41.5kg"):', curName);
      if (name == null || !name.trim() || name.trim() === curName) return;
      vr.disabled = true; vr.textContent = 'Renaming…';
      AG_ADMIN.api('ui_rename_variant', { variantId: form.variantId, name: name.trim() }).then(function () {
        AG_ADMIN.toast('Variant renamed');
        if (cur) cur.title = name.trim();
        renderForm();
      }).catch(function (e) {
        AG_ADMIN.toast('Rename failed: ' + e.message, true);
        vr.disabled = false; vr.textContent = '✎ Rename variant';
      });
    };
    wireVariantTools();
    view().querySelectorAll('[data-mode]').forEach(function (n) { n.onclick = function () { if (form.kind !== n.dataset.mode) { form.kind = n.dataset.mode; form.dirty = true; renderForm(); refreshPreview(); } }; });
    view().querySelectorAll('[data-pmode]').forEach(function (n) { n.onclick = function () {
      if (form.parentMode === n.dataset.pmode) return;
      form.parentMode = n.dataset.pmode;
      if (form.parentMode === 'new') { form.productId = null; form.variantId = null; } // back to create-new
      renderForm();
    }; });
    var pc = $('f-parent-clear'); if (pc) pc.onclick = function () { form.productId = null; form.variantId = null; renderForm(); };
    wireParentSearch();
    bind('f-title', 'title'); bind('f-key', 'parentKey');
    $('f-active').onchange = function () { form.active = this.checked; };
    if (assembly) {
      var pn = $('f-price'); if (pn) pn.oninput = function () { form.price = this.value; refreshPreview(); };
    } else {
      bind('f-label', 'label');
      $('f-rmode').onchange = function () { form.rewardMode = this.value; var l = $('f-rval-lbl'); if (l) l.textContent = this.value === 'price' ? 'Bundle price' : 'Value'; refreshPreview(); };
      $('f-rval').oninput = function () { form.rewardValue = this.value; refreshPreview(); };
      $('f-codes').onchange = function () { form.codes = this.value; };
      $('f-ship').onchange = function () { form.combinesWithShipping = this.checked; };
      $('f-preorder').onchange = function () { form.allowPreorder = this.checked; };
    }
    wireSearch();
    renderComponents();
    renderSeoSection();
    var formBox = view().querySelector('.ag-bnd-form');
    if (formBox) {
      var markDirty = function (ev) {
        var t = ev.target; if (!t) return;
        if (t.id === 'f-search' || t.id === 'f-parent-search' || t.id === 'f-variant') return; // search/navigation, not edits
        form.dirty = true;
      };
      formBox.addEventListener('input', markDirty);
      formBox.addEventListener('change', markDirty);
    }
  }
  function bind(id, key) { var n = $(id); n.oninput = function () { form[key] = n.value; }; }

  function renderSeoSection() {
    var box = $('f-seo'); if (!box) return;
    if (!form.productId || !form.isEdit) { box.innerHTML = '<div class="ag-bnd-seo-head"><h4>SEO</h4></div><p class="ag-dim">Save the bundle first, then optimise its search listing here.</p>'; return; }
    if (!form.seo) { box.innerHTML = '<div class="ag-bnd-seo-head"><h4>SEO</h4></div><p class="ag-dim">Loading…</p>'; return; }
    var s = form.seo;
    box.innerHTML =
      '<div class="ag-bnd-seo-head"><h4>SEO</h4><span id="seo-score"></span></div>' +
      '<label class="ag-fld"><span>SEO title</span><input id="seo-title" type="text" value="' + esc(s.seoTitle || '') + '" placeholder="' + esc(s.title || '') + '"></label>' +
      '<label class="ag-fld"><span>Meta description</span><textarea id="seo-desc" rows="2">' + esc(s.seoDescription || '') + '</textarea></label>' +
      '<label class="ag-fld"><span>Image alt text</span><input id="seo-alt" type="text" value="' + esc(s.imageAlt || '') + '"' + (s.hasImage ? '' : ' disabled placeholder="no featured image set"') + '></label>' +
      '<label class="ag-fld"><span>Product description (HTML allowed)</span><textarea id="seo-body" rows="4">' + esc(s.bodyHtml || '') + '</textarea></label>' +
      '<ul id="seo-checks" class="ag-bnd-seo-checks"></ul>' +
      '<div><button class="ag-btn" id="seo-save">Save SEO</button></div>';
    function on(id, key, clearBody) { var n = $(id); if (n) n.oninput = function () { form.seo[key] = n.value; if (clearBody) form.seo.bodyText = null; updateSeoEval(); }; }
    on('seo-title', 'seoTitle'); on('seo-desc', 'seoDescription'); on('seo-alt', 'imageAlt'); on('seo-body', 'bodyHtml', true);
    $('seo-save').onclick = saveSeo;
    updateSeoEval();
  }
  function updateSeoEval() {
    var ev = seoEval(form.seo || {});
    var sc = $('seo-score'); if (sc) sc.innerHTML = seoBadge(ev.score);
    var ul = $('seo-checks'); if (ul) ul.innerHTML = ev.checks.map(function (c) {
      return '<li class="' + (c.ok ? 'ok' : (c.level === 'fail' ? 'fail' : 'warn')) + '">' + (c.ok ? '✓' : '•') + ' ' + esc(c.msg) + '</li>';
    }).join('');
  }
  function saveSeo() {
    var btn = $('seo-save'); btn.disabled = true; btn.textContent = 'Saving…';
    AG_ADMIN.api('ui_seo_save', { productId: form.productId, seo: {
      seoTitle: form.seo.seoTitle, seoDescription: form.seo.seoDescription, bodyHtml: form.seo.bodyHtml, imageAlt: form.seo.imageAlt
    } }).then(function () {
      AG_ADMIN.toast('SEO saved'); btn.disabled = false; btn.textContent = 'Save SEO';
    }).catch(function (e) { AG_ADMIN.toast('SEO save failed: ' + e.message, true); btn.disabled = false; btn.textContent = 'Save SEO'; });
  }

  /* Parent-product picker (assembly "Convert existing product"). Selecting a product sets
     form.productId/variantId so save() converts that product in place instead of creating a new one. */
  function wireParentSearch() {
    var input = $('f-parent-search'), results = $('f-parent-results');
    if (!input || !results) return;
    input.oninput = function () {
      var term = input.value.trim().toLowerCase();
      if (!term) { results.classList.add('hidden'); return; }
      if (!state.products) {
        results.innerHTML = '<div class="ag-bnd-result ag-dim">' + (state.productsLoading ? 'Loading product list…' : 'Product list not loaded yet. Try again in a moment.') + '</div>';
        results.classList.remove('hidden'); return;
      }
      var matches = state.products.filter(function (p) {
        return p.productId && ((p.title && p.title.toLowerCase().indexOf(term) !== -1) || (p.sku && p.sku.toLowerCase().indexOf(term) !== -1));
      }).slice(0, 30);
      results.innerHTML = matches.length ? matches.map(function (x) {
        return '<div class="ag-bnd-result" data-pid="' + esc(x.productId) + '" data-vid="' + esc(x.variantId) + '" data-title="' + esc(x.title) + '" data-ptitle="' + esc(x.productTitle || x.title) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '">' : '<span class="ag-bnd-thumb"></span>') +
          '<span>' + esc(x.title) + '</span><b>' + money(x.price) + '</b></div>';
      }).join('') : '<div class="ag-bnd-result ag-dim">No matches</div>';
      results.classList.remove('hidden');
      results.querySelectorAll('[data-pid]').forEach(function (n) {
        n.onclick = function () {
          form.productId = n.dataset.pid;
          form.variantId = n.dataset.vid;
          // Prefill from the raw PRODUCT title. dataset.title is the picker's display label
          // ("Product - Variant"); saving it renames the product to that composed string, which is
          // what mangled the Gen 6 product live on 2026-08-21. Fall back only for old cached
          // payloads that predate productTitle.
          if (!form.title || !form.title.trim()) form.title = n.dataset.ptitle || n.dataset.title;
          results.classList.add('hidden');
          renderForm();
        };
      });
    };
    document.addEventListener('click', function onDoc(ev) {
      if (!document.body.contains(input)) { document.removeEventListener('click', onDoc); return; }
      if (!results.contains(ev.target) && ev.target !== input) results.classList.add('hidden');
    });
  }

  function wireSearch() {
    var input = $('f-search'), results = $('f-results');
    var liveTimer = null;
    function renderResults(list, emptyMsg) {
      results.innerHTML = list.length ? list.map(function (x) {
        return '<div class="ag-bnd-result" data-id="' + esc(x.variantId) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '">' : '<span class="ag-bnd-thumb"></span>') +
          '<span>' + esc(x.title) + (x.sku ? ' <span class="ag-dim" style="font-size:11px;">' + esc(x.sku) + '</span>' : '') + '</span><b>' + money(x.price) + '</b></div>';
      }).join('') : ('<div class="ag-bnd-result ag-dim">' + emptyMsg + '</div>');
      results.classList.remove('hidden');
      results.querySelectorAll('[data-id]').forEach(function (n) {
        n.onclick = function () { addComponent(n.dataset.id); results.classList.add('hidden'); input.value = ''; };
      });
    }
    input.oninput = function () {
      var term = input.value.trim().toLowerCase();
      if (!term) { results.classList.add('hidden'); return; }
      /* Local (cached) matches first, instant. */
      var matches = (state.products || []).filter(function (p) {
        return (p.title && p.title.toLowerCase().indexOf(term) !== -1) || (p.sku && p.sku.toLowerCase().indexOf(term) !== -1);
      }).slice(0, 30);
      if (matches.length) { renderResults(matches, 'No matches'); return; }
      /* No cached match, a just-added product/box may not be in the ~15-min
         cached list yet. Fall back to a LIVE Shopify search (debounced) so new
         boxes are findable immediately. */
      results.innerHTML = '<div class="ag-bnd-result ag-dim">Searching Shopify…</div>';
      results.classList.remove('hidden');
      clearTimeout(liveTimer);
      liveTimer = setTimeout(function () {
        var raw = input.value.trim();
        if (raw.length < 2) return;
        AG_ADMIN.api('ui_search_products', { term: raw }).then(function (r) {
          if (input.value.trim() !== raw) return; // user kept typing, ignore stale response
          renderResults((r.results || []).slice(0, 30), 'No matches (checked Shopify live too)');
        }).catch(function () { results.innerHTML = '<div class="ag-bnd-result ag-dim">Search failed. Try again.</div>'; });
      }, 350);
    };
    document.addEventListener('click', function onDoc(ev) {
      if (!document.body.contains(input)) { document.removeEventListener('click', onDoc); return; }
      if (!results.contains(ev.target) && ev.target !== input) results.classList.add('hidden');
    });
  }

  function addComponent(id) {
    if (form.components.some(function (c) { return c.id === id; })) { AG_ADMIN.toast('Already added'); return; }
    if (form.variantId && id === form.variantId) { AG_ADMIN.toast("That's the parent product. It can't also be a box", true); return; }
    form.dirty = true;
    // Assembly mode: if the picked product is ITSELF a native bundle, auto-expand it into its
    // component boxes (no nested-bundle error; the assembly derives stock from the boxes, no
    // manual input). Phase 4 retires the duplicates that make this necessary.
    if (form.kind === 'assembly') {
      AG_ADMIN.api('ui_expand_component', { variantId: id }).then(function (r) {
        if (r && r.expanded && r.components && r.components.length) {
          var added = 0;
          r.components.forEach(function (b) {
            if (form.components.some(function (c) { return c.id === b.id; })) return;
            previewById[b.id] = { title: b.title, variantTitle: b.variantTitle, price: 0 };
            form.components.push({ id: b.id, qty: b.qty || 1, role: 'component' });
            added++;
          });
          AG_ADMIN.toast(added ? ('Expanded bundle → ' + added + ' box' + (added === 1 ? '' : 'es')) : 'Boxes already added');
        } else {
          form.components.push({ id: id, qty: 1, role: form.components.length ? 'component' : 'base' });
        }
        renderComponents(); refreshPreview();
      }).catch(function () {
        form.components.push({ id: id, qty: 1, role: form.components.length ? 'component' : 'base' });
        renderComponents(); refreshPreview();
      });
      return;
    }
    form.components.push({ id: id, qty: 1, role: form.components.length ? 'component' : 'base' });
    renderComponents(); refreshPreview();
  }

  function renderComponents() {
    var wrap = $('f-components');
    if (!form.components.length) { wrap.innerHTML = '<div class="ag-dim ag-bnd-nocomp">No components yet. Search above to add.</div>'; return; }
    wrap.innerHTML = form.components.map(function (c, i) {
      var info = previewById[c.id] || {};
      var name = info.title ? (esc(info.title) + (info.variantTitle ? ' \u00b7 ' + esc(info.variantTitle) : '')) : '…';
      var price = info.price != null ? money(info.price) : '';
      return '<div class="ag-bnd-comp">' +
        '<span class="ag-bnd-compname">' + name + ' <span class="ag-dim">' + price + '</span></span>' +
        '<label class="ag-bnd-qty">qty <input type="number" min="1" step="1" value="' + c.qty + '" data-qty="' + i + '"></label>' +
        '<select data-role="' + i + '"><option value="base"' + (c.role === 'base' ? ' selected' : '') + '>base</option><option value="component"' + (c.role !== 'base' ? ' selected' : '') + '>component</option></select>' +
        '<button class="ag-btn ag-btn-danger" data-rm="' + i + '">×</button>' +
      '</div>';
    }).join('');
    wrap.querySelectorAll('[data-qty]').forEach(function (n) { n.onchange = function () { form.components[+n.dataset.qty].qty = Math.max(1, parseInt(n.value, 10) || 1); refreshPreview(); }; });
    wrap.querySelectorAll('[data-role]').forEach(function (n) { n.onchange = function () { form.components[+n.dataset.role].role = n.value; }; });
    wrap.querySelectorAll('[data-rm]').forEach(function (n) { n.onclick = function () { form.components.splice(+n.dataset.rm, 1); form.dirty = true; renderComponents(); refreshPreview(); }; });
  }

  function refreshPreview() {
    clearTimeout(previewTimer);
    var pv = $('f-preview'); if (!pv) return;
    if (!form.components.length) { pv.innerHTML = ''; return; }
    pv.innerHTML = '<div class="ag-dim">Calculating…</div>';
    previewTimer = setTimeout(function () {
      // Always call ui_preview to resolve component names/prices (both modes); display per-mode.
      AG_ADMIN.api('ui_preview', { bundle: { components: form.components, reward: { mode: form.rewardMode, value: form.rewardValue } } })
        .then(function (p) {
          previewById = {}; (p.lines || []).forEach(function (l) { previewById[l.id] = l; });
          previewTotals = p;
          renderComponents(); // fill in titles/prices now we have them
          var warn = (p.warnings && p.warnings.length) ? '<div class="ag-bnd-warn">⚠ ' + p.warnings.map(esc).join('<br>⚠ ') + '</div>' : '';
          if (form.kind === 'assembly') {
            pv.innerHTML = warn +
              '<div class="ag-bnd-prevrow ag-bnd-total"><span>Sells at</span><b>' + money(form.price) + '</b></div>' +
              '<div class="ag-dim">Made of ' + form.components.length + ' component box' + (form.components.length === 1 ? '' : 'es') + '. Stock is derived from the boxes (Shopify decrements them on sale; the customer sees one product).</div>';
          } else {
            pv.innerHTML = warn +
              '<div class="ag-bnd-prevrow"><span>Component total</span><b>' + money(p.subtotal) + '</b></div>' +
              '<div class="ag-bnd-prevrow ag-bnd-saving"><span>Bundle saving</span><b>−' + money(p.saving) + '</b></div>' +
              '<div class="ag-bnd-prevrow ag-bnd-total"><span>Bundle price</span><b>' + money(p.bundlePrice) + '</b></div>';
          }
        }).catch(function (e) { pv.innerHTML = '<div class="ag-dim">Preview failed: ' + esc(e.message) + '</div>'; });
    }, 300);
  }

  function save() {
    if (!form.title.trim()) { AG_ADMIN.toast('Add a bundle name', true); return; }
    if (form.kind === 'assembly' && form.parentMode === 'existing' && !form.productId) { AG_ADMIN.toast('Pick the product to convert, or switch to "Create new product"', true); return; }
    if (!form.components.length) { AG_ADMIN.toast(form.kind === 'assembly' ? 'Add at least one box' : 'Add at least one component', true); return; }
    if (form.kind === 'assembly' && !(Number(form.price) > 0)) { AG_ADMIN.toast('Set the bundle price', true); return; }
    var btn = $('bnd-save'); btn.disabled = true; btn.textContent = 'Saving…';
    var payload = form.kind === 'assembly'
      ? { kind: 'assembly', productId: form.productId, variantId: form.variantId, title: form.title, parentKey: form.parentKey,
          components: form.components, price: Number(form.price) || 0, active: form.active }
      : { kind: 'bundle', productId: form.productId, variantId: form.variantId, title: form.title, parentKey: form.parentKey,
          components: form.components,
          reward: { mode: form.rewardMode, value: Number(form.rewardValue) || 0 },
          label: form.label,
          stacking: { codes: form.codes, combinesWithShipping: form.combinesWithShipping },
          availability: { allowPreorderComponents: form.allowPreorder },
          active: form.active };
    AG_ADMIN.api('ui_save_bundle', { bundle: payload }).then(function (r) {
      if (r && r.rename && r.rename.warning) AG_ADMIN.toast('Saved. ' + r.rename.warning, true);
      else if (r && r.rename && r.rename.redirectFrom) AG_ADMIN.toast('Bundle saved · product renamed to "' + (r.rename.renamedTo || form.title) + '" · URL updated, old link redirects');
      else if (r && r.rename) AG_ADMIN.toast('Bundle saved · product renamed to "' + (r.rename.renamedTo || form.title) + '"');
      else AG_ADMIN.toast('Bundle saved');
      clearDirty(); leaveForm('bundles');
    }).catch(function (e) {
      AG_ADMIN.toast('Save failed: ' + e.message, true); btn.disabled = false; btn.textContent = 'Save bundle';
    });
  }

  /* ---------------- CSV import (bulk create / migration) ---------------- */
  var SAMPLE_CSV = 'name,kind,sku,components,reward_type,reward_value,price,codes,label,active\n' +
    '"Chrome Dumbbell Kit",bundle,BUNDLE-CHROME,"DB-CHROME-24:1|MAT-BLK:1",pct,10,,none,Bundle saving,true\n' +
    '"Adjustable Dumbbell 90kg",assembly,BUNDLE-DB90,"BOX-A:2|BOX-B:2",,,199,,,true';

  function openImport() {
    var ov = document.createElement('div');
    ov.className = 'ag-bnd-modal-overlay'; ov.id = 'bnd-import-modal';
    ov.innerHTML =
      '<div class="ag-bnd-modal">' +
        '<div class="ag-bnd-modal-head"><h3>Import / Restore bundles</h3><button class="ag-btn" id="imp-close">✕</button></div>' +
        '<p class="ag-dim"><b>CSV</b> (bulk-create): one row per bundle, <b>components</b> = <code>SKU:qty</code> joined by <code>|</code>, <b>kind</b> = <code>bundle</code>/<code>assembly</code>. ' +
          'or, <b>paste a backup JSON</b> (from the ⤓ Backup button) to <b>restore</b> bundles (rebuilds them as new products).</p>' +
        '<textarea id="imp-csv" rows="8" spellcheck="false" placeholder="Paste CSV, or a backup JSON, here…">' + esc(SAMPLE_CSV) + '</textarea>' +
        '<div class="ag-bnd-modal-foot">' +
          '<button class="ag-btn" id="imp-preview">Preview</button>' +
          '<button class="ag-btn ag-btn-primary hidden" id="imp-go">Import</button>' +
        '</div>' +
        '<div id="imp-out"></div>' +
      '</div>';
    document.body.appendChild(ov);
    $('imp-close').onclick = function () { ov.remove(); };
    ov.onclick = function (e) { if (e.target === ov) ov.remove(); };
    $('imp-preview').onclick = function () {
      var raw = $('imp-csv').value.trim();
      if (raw.charAt(0) === '{' || raw.charAt(0) === '[') { // backup JSON → restore
        var data; try { data = JSON.parse(raw); } catch (e) { $('imp-out').innerHTML = '<div class="ag-bnd-warn">Invalid JSON: ' + esc(e.message) + '</div>'; return; }
        var bundles = Array.isArray(data) ? data : (data.bundles || []);
        $('imp-out').innerHTML = '<div class="ag-bnd-imp-summary">Backup detected, <b>' + bundles.length + '</b> bundle(s) to RESTORE.' + (data.generatedAt ? ' (from ' + esc(data.generatedAt) + ')' : '') + ' <span class="ag-bnd-warn-inline">Creates new products.</span></div>';
        var goR = $('imp-go'); goR.classList.remove('hidden'); goR.textContent = 'Restore ' + bundles.length + ' bundle(s)';
        goR.onclick = function () { doRestore(bundles, ov); };
        return;
      }
      var rows = parseCsv(raw);
      var bad = rows.filter(function (r) { return !r.name || !r.components.length || (r.kind === 'assembly' && !(r.price > 0)); });
      $('imp-out').innerHTML =
        '<div class="ag-bnd-imp-summary">' + rows.length + ' row(s) parsed' + (bad.length ? (' · <span class="ag-bnd-warn-inline">' + bad.length + ' look invalid</span>') : '') + '</div>' +
        '<table class="ag-bnd-table"><thead><tr><th>Name</th><th>Kind</th><th>Components</th><th>Reward / price</th></tr></thead><tbody>' +
        rows.map(function (r) {
          var rv = r.kind === 'assembly' ? money(r.price) : (r.reward.type === 'pct' ? r.reward.value + '%' : (r.reward.type === 'price' ? '→' + money(r.reward.value) : money(r.reward.value)));
          var ok = r.name && r.components.length && !(r.kind === 'assembly' && !(r.price > 0));
          return '<tr' + (ok ? '' : ' class="sel"') + '><td>' + esc(r.name || '-') + '</td><td>' + esc(r.kind) + '</td><td>' + r.components.length + '</td><td>' + esc(rv) + '</td></tr>';
        }).join('') + '</tbody></table>';
      var go = $('imp-go'); go.classList.remove('hidden'); go.textContent = 'Import ' + rows.length + ' bundle(s)';
      go.onclick = function () { doImport(rows, ov); };
    };
  }

  function doImport(rows, ov) {
    if (!rows.length) return;
    var go = $('imp-go'); go.disabled = true;
    var out = $('imp-out');
    var CHUNK = 10, all = [], i = 0;
    function next() {
      if (i >= rows.length) { finish(); return; }
      var batch = rows.slice(i, i + CHUNK);
      out.innerHTML = '<div class="ag-bnd-imp-summary">Importing ' + (i + 1) + '–' + Math.min(i + CHUNK, rows.length) + ' of ' + rows.length + '…</div>';
      AG_ADMIN.api('ui_import_bundles', { rows: batch }).then(function (r) {
        all = all.concat(r.results || []); i += CHUNK; next();
      }).catch(function (e) {
        batch.forEach(function (b) { all.push({ name: b.name, ok: false, error: e.message }); });
        i += CHUNK; next();
      });
    }
    function finish() {
      var okN = all.filter(function (r) { return r.ok; }).length;
      var errs = all.filter(function (r) { return !r.ok; });
      out.innerHTML = '<div class="ag-bnd-imp-summary"><b>' + okN + ' created</b>' + (errs.length ? (' · ' + errs.length + ' failed') : '') + '</div>' +
        (errs.length ? '<ul class="ag-bnd-seo-checks">' + errs.map(function (r) { return '<li class="fail">' + esc(r.name) + ': ' + esc(r.error) + '</li>'; }).join('') + '</ul>' : '');
      AG_ADMIN.toast(okN + ' bundle(s) imported');
      go.textContent = 'Done';
      setTimeout(function () { if (ov && ov.parentNode) { ov.remove(); } boot(); }, errs.length ? 3500 : 1200);
    }
    next();
  }

  function doBackup() {
    AG_ADMIN.toast('Preparing backup…');
    AG_ADMIN.api('ui_backup', {}).then(function (r) {
      var blob = new Blob([JSON.stringify(r, null, 2)], { type: 'application/json' });
      var url = URL.createObjectURL(blob), a = document.createElement('a');
      a.href = url; a.download = 'ag-bundles-backup-' + String(r.generatedAt || '').slice(0, 10) + '.json';
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      AG_ADMIN.toast('Backed up ' + (r.count || 0) + ' bundle(s). Keep the file safe');
    }).catch(function (e) { AG_ADMIN.toast('Backup failed: ' + e.message, true); });
  }

  function doRestore(bundles, ov) {
    if (!bundles.length) return;
    var go = $('imp-go'); go.disabled = true; var out = $('imp-out');
    var CHUNK = 8, all = [], i = 0;
    function next() {
      if (i >= bundles.length) { finish(); return; }
      var batch = bundles.slice(i, i + CHUNK);
      out.innerHTML = '<div class="ag-bnd-imp-summary">Restoring ' + (i + 1) + '–' + Math.min(i + CHUNK, bundles.length) + ' of ' + bundles.length + '…</div>';
      AG_ADMIN.api('ui_restore', { bundles: batch }).then(function (r) { all = all.concat(r.results || []); i += CHUNK; next(); })
        .catch(function (e) { batch.forEach(function (b) { all.push({ title: b.title, ok: false, error: e.message }); }); i += CHUNK; next(); });
    }
    function finish() {
      var okN = all.filter(function (r) { return r.ok; }).length, errs = all.filter(function (r) { return !r.ok; });
      out.innerHTML = '<div class="ag-bnd-imp-summary"><b>' + okN + ' restored</b>' + (errs.length ? (' · ' + errs.length + ' failed') : '') + '</div>' +
        (errs.length ? '<ul class="ag-bnd-seo-checks">' + errs.map(function (r) { return '<li class="fail">' + esc(r.title) + ': ' + esc(r.error) + '</li>'; }).join('') + '</ul>' : '');
      AG_ADMIN.toast(okN + ' restored'); go.textContent = 'Done';
      setTimeout(function () { if (ov && ov.parentNode) ov.remove(); boot(); }, errs.length ? 3500 : 1200);
    }
    next();
  }

  function parseCsv(text) {
    var lines = String(text || '').split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (lines.length < 2) return [];
    var headers = splitCsvLine(lines[0]).map(function (h) { return h.trim().toLowerCase(); });
    return lines.slice(1).map(function (l) {
      var cells = splitCsvLine(l), o = {};
      headers.forEach(function (h, i) { o[h] = (cells[i] || '').trim(); });
      return {
        name: o.name || '',
        kind: o.kind === 'assembly' ? 'assembly' : 'bundle',
        sku: o.sku || '',
        components: (o.components || '').split('|').map(function (p) {
          var x = p.split(':'); return { sku: (x[0] || '').trim(), qty: parseInt(x[1], 10) || 1 };
        }).filter(function (c) { return c.sku; }),
        reward: { type: o.reward_type || 'pct', value: parseFloat(o.reward_value) || 0 },
        price: parseFloat(o.price) || 0,
        codes: o.codes || 'none',
        label: o.label || '',
        active: o.active !== 'false'
      };
    });
  }
  // minimal CSV line splitter (handles double-quoted fields with commas)
  function splitCsvLine(line) {
    var out = [], cur = '', q = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      if (q) { if (ch === '"') { if (line[i + 1] === '"') { cur += '"'; i++; } else q = false; } else cur += ch; }
      else { if (ch === '"') q = true; else if (ch === ',') { out.push(cur); cur = ''; } else cur += ch; }
    }
    out.push(cur); return out;
  }

  /* ============================================================
     Builder add-ons (Phase 4 Stage A), configurable bundles UI
     ============================================================
     Each base product carries a $app:bundles.builder_config metafield
     with the config shape:
       { version, groups: [{ key, label, required, multi,
           items: [{ key, variantId, label, saving, savingType,
                     legacyVids: [], preorder }] }] }
     Saving each entry mirrors `saving` onto every add-on variant's
     $app:bundles.builder metafield (read by the discount function). */

  function bootAddons() {
    cfgForm = null;
    view().innerHTML = '<div class="ag-empty">Loading configurable bases…</div>';
    /* Prefetch the product list, the variant picker uses the same
       cached list as the bundles form so search is instant. */
    ensureProducts();
    if (state.cfgConfigs) { renderAddonsList(); return; }
    if (state.cfgConfigsLoading) return;
    state.cfgConfigsLoading = true;
    AG_ADMIN.api('ui_cfg_list', {}).then(function (r) {
      state.cfgConfigs = r.configs || [];
      state.cfgConfigsLoading = false;
      renderAddonsList();
    }).catch(function (e) {
      state.cfgConfigsLoading = false;
      view().innerHTML = '<div class="ag-empty">Failed to load: ' + esc(e.message) + '</div>';
    });
  }

  function renderAddonsList() {
    var rows = state.cfgConfigs || [];
    if (!rows.length) {
      view().innerHTML =
        '<div class="ag-empty">No configurable bases yet.<br><span class="ag-dim">' +
        'Click <b>+ Configure a base</b> to set up the add-ons (real variant + saving) for a base product. ' +
        'Saving each base auto-mirrors the saving onto every add-on variant so the discount function can read it.' +
        '</span></div>';
      return;
    }
    view().innerHTML = '<div class="ag-bnd-cfg-list">' + rows.map(function (r) {
      return '<div class="ag-bnd-cfg-row" data-id="' + esc(r.productId) + '">' +
        (r.image ? '<img src="' + esc(r.image) + '">' : '<span class="ag-bnd-thumb"></span>') +
        '<div><div>' + esc(r.title) + '</div>' +
          '<div class="meta">' + (r.groups || 0) + ' group' + (r.groups === 1 ? '' : 's') +
          ' · ' + (r.addOns || 0) + ' add-on' + (r.addOns === 1 ? '' : 's') + '</div></div>' +
        '<span class="spacer"></span><span class="ag-dim">edit ›</span></div>';
    }).join('') + '</div>';
    view().querySelectorAll('[data-id]').forEach(function (n) {
      n.onclick = function () { openAddonsForm(n.dataset.id); };
    });
  }

  function openAddonsForm(baseProductId) {
    if (!formOpen()) pushView();
    cfgForm = { baseProductId: baseProductId || null, base: null, config: null,
      addOnInfo: {}, picker: { groupIdx: -1 } };
    /* Picker case, no base selected yet, render a product search. */
    if (!baseProductId) { renderAddonsBasePicker(); return; }
    view().innerHTML = '<div class="ag-empty">Loading config…</div>';
    AG_ADMIN.api('ui_cfg_get', { productId: baseProductId }).then(function (r) {
      cfgForm.base = { title: r.baseTitle, status: r.baseStatus, variants: r.baseVariants || [] };
      cfgForm.config = normaliseConfig_(r.config || {});
      cfgForm.addOnInfo = r.addOnInfo || {};
      renderAddonsForm();
    }).catch(function (e) {
      view().innerHTML = '<div class="ag-empty">Failed to load config: ' + esc(e.message) + '</div>';
    });
  }

  /* Map the persisted config into the canonical shape the form expects.
     Defensive, missing keys/fields default to safe values; legacyVids
     is normalised to an array of numeric-string ids. */
  function normaliseConfig_(c) {
    c = c || {};
    var groups = (c.groups || []).map(function (g) {
      return {
        key: g.key || '', label: g.label || '',
        required: !!g.required, multi: g.multi !== false,
        items: (g.items || []).map(function (it) {
          var legacy = it.legacyVids;
          if (!Array.isArray(legacy)) legacy = String(legacy || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          return {
            key: it.key || '', variantId: it.variantId || '',
            label: it.label || '', saving: Number(it.saving) || 0,
            savingType: 'fixed', // AGPB add-on savings are flat £ only (pct never honored by theme/checkout)
            legacyVids: legacy, preorder: !!it.preorder
          };
        })
      };
    });
    return { version: c.version || 1, groups: groups };
  }

  function renderAddonsBasePicker() {
    view().innerHTML =
      '<div class="ag-bnd-form">' +
        '<div class="ag-bnd-formhead"><h3>Pick a base product</h3>' +
          '<button class="ag-btn" id="bnd-cfg-cancel">← Back</button></div>' +
        '<div class="ag-fld"><span>Base product (the dumbbell pair customers configure)</span>' +
          '<div class="ag-bnd-search"><input id="cfg-base-search" type="text" placeholder="Search products to pick the base…" autocomplete="off">' +
          '<div id="cfg-base-results" class="ag-bnd-results hidden"></div></div></div>' +
      '</div>';
    /* NOT setSection('addons'), that early-returns when the section is
       already 'addons' (which it always is here), leaving the button dead. */
    $('bnd-cfg-cancel').onclick = function () { leaveForm('addons'); };
    var input = $('cfg-base-search'), results = $('cfg-base-results');
    input.oninput = function () {
      var term = input.value.trim().toLowerCase();
      if (!term) { results.classList.add('hidden'); return; }
      if (!state.products) {
        results.innerHTML = '<div class="ag-bnd-result ag-dim">' + (state.productsLoading ? 'Loading product list…' : 'Product list not loaded.') + '</div>';
        results.classList.remove('hidden'); return;
      }
      /* Show one row per PRODUCT (collapse variants, the base is a
         product, not a single variant). De-dup by title. */
      var seen = {}, matches = [];
      state.products.forEach(function (p) {
        var key = splitPickLabel(p.title).product;
        if (seen[key]) return; seen[key] = true;
        if (key.toLowerCase().indexOf(term) === -1) return;
        var productGid = String(p.variantId).replace('ProductVariant', 'Product');
        /* We can't derive the product gid from the variant gid reliably,
           so use the cached productId where possible. The cached list
           doesn't carry productId today, fall back to variantId-as-pick
           and let the backend resolve via the variant's product. */
        matches.push({ display: key, image: p.image, variantId: p.variantId });
      });
      matches = matches.slice(0, 30);
      results.innerHTML = matches.length ? matches.map(function (x) {
        return '<div class="ag-bnd-result" data-vid="' + esc(x.variantId) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '">' : '<span class="ag-bnd-thumb"></span>') +
          '<span>' + esc(x.display) + '</span></div>';
      }).join('') : '<div class="ag-bnd-result ag-dim">No matches</div>';
      results.classList.remove('hidden');
      results.querySelectorAll('[data-vid]').forEach(function (n) {
        n.onclick = function () {
          /* Add-ons are configured on the base PRODUCT, but this picker yields a
             VARIANT, so ui_cfg_resolve_base maps the variant back to its product id. */
          var vid = n.dataset.vid;
          AG_ADMIN.api('ui_cfg_resolve_base', { variantId: vid }).then(function (r) {
            if (!r || !r.productId) { AG_ADMIN.toast('Could not resolve product from variant', true); return; }
            openAddonsForm(r.productId);
          }).catch(function (e) { AG_ADMIN.toast('Resolve failed: ' + e.message, true); });
        };
      });
    };
    document.addEventListener('click', function onDoc(ev) {
      if (!document.body.contains(input)) { document.removeEventListener('click', onDoc); return; }
      if (!results.contains(ev.target) && ev.target !== input) results.classList.add('hidden');
    });
  }

  function renderAddonsForm() {
    var c = cfgForm.config, base = cfgForm.base || {};
    view().innerHTML =
      '<div class="ag-bnd-cfg-form">' +
        '<div class="ag-bnd-formhead"><h3>' + esc(base.title || 'Base') +
          ' <span class="ag-dim" style="font-weight:400;font-size:12px;">add-on config</span></h3>' +
          '<button class="ag-btn" id="bnd-cfg-back">← Back to list</button></div>' +

        '<div id="cfg-groups"></div>' +

        '<div class="ag-bnd-cfg-actions">' +
          '<button class="ag-btn" id="cfg-add-group" type="button">+ Add group</button>' +
          '<span class="spacer" style="flex:1;"></span>' +
          '<button class="ag-btn ag-btn-primary" id="cfg-save" type="button">Save config</button>' +
        '</div>' +
        '<p class="ag-dim">Groups bundle related add-ons (e.g. Bench, Stand, Warranty). Each item picks a <b>real</b> variant + the <b>£ saving</b> the customer gets via the builder. Saving each item is mirrored onto the variant\'s metafield so the discount function can apply it server-side.</p>' +
      '</div>';
    /* NOT setSection('addons'), that early-returns when the section is
       already 'addons' (which it always is here), leaving the button dead. */
    $('bnd-cfg-back').onclick = function () { leaveForm('addons'); };
    $('cfg-add-group').onclick = function () {
      c.groups.push({ key: '', label: 'New group', required: false, multi: true, items: [] });
      cfgForm.dirty = true;
      renderAddonsGroups();
    };
    $('cfg-save').onclick = saveAddonsForm;
    var cfgBox = view().querySelector('.ag-bnd-cfg-form');
    if (cfgBox) {
      var markCfgDirty = function (ev) {
        var t = ev.target; if (!t) return;
        if (t.hasAttribute && t.hasAttribute('data-pick')) return; // variant search box, not an edit
        cfgForm.dirty = true;
      };
      cfgBox.addEventListener('input', markCfgDirty);
      cfgBox.addEventListener('change', markCfgDirty);
    }
    renderAddonsGroups();
  }

  function renderAddonsGroups() {
    var wrap = $('cfg-groups');
    if (!wrap) return;
    var c = cfgForm.config;
    if (!c.groups.length) {
      wrap.innerHTML = '<div class="ag-bnd-cfg-empty">No groups yet. Click <b>+ Add group</b> to start.</div>';
      return;
    }
    wrap.innerHTML = c.groups.map(function (g, gi) {
      return '<div class="ag-bnd-cfg-group" data-gi="' + gi + '">' +
        '<div class="ag-bnd-cfg-group-head">' +
          '<label class="ag-fld"><span>Group label</span><input type="text" data-grp-label="' + gi + '" value="' + esc(g.label) + '" placeholder="e.g. Bench"></label>' +
          '<label class="ag-fld"><span>Key (URL slug)</span><input type="text" data-grp-key="' + gi + '" value="' + esc(g.key) + '" placeholder="auto from label"></label>' +
          '<label class="ag-chk"><input type="checkbox" data-grp-req="' + gi + '"' + (g.required ? ' checked' : '') + '> Required</label>' +
          '<label class="ag-chk"><input type="checkbox" data-grp-multi="' + gi + '"' + (g.multi ? ' checked' : '') + '> Multi-select</label>' +
          '<button class="ag-btn ag-btn-danger" data-grp-rm="' + gi + '" type="button">×</button>' +
        '</div>' +
        '<div data-grp-items="' + gi + '"></div>' +
        '<div><button class="ag-btn" data-grp-additem="' + gi + '" type="button">+ Add item</button></div>' +
      '</div>';
    }).join('');
    c.groups.forEach(function (_, gi) { renderAddonsItems(gi); });
    wrap.querySelectorAll('[data-grp-label]').forEach(function (n) {
      n.oninput = function () { c.groups[+n.dataset.grpLabel].label = n.value; };
    });
    wrap.querySelectorAll('[data-grp-key]').forEach(function (n) {
      n.oninput = function () { c.groups[+n.dataset.grpKey].key = n.value; };
    });
    wrap.querySelectorAll('[data-grp-req]').forEach(function (n) {
      n.onchange = function () { c.groups[+n.dataset.grpReq].required = n.checked; };
    });
    wrap.querySelectorAll('[data-grp-multi]').forEach(function (n) {
      n.onchange = function () { c.groups[+n.dataset.grpMulti].multi = n.checked; };
    });
    wrap.querySelectorAll('[data-grp-rm]').forEach(function (n) {
      n.onclick = function () {
        if (!confirm('Remove this group and its items?')) return;
        c.groups.splice(+n.dataset.grpRm, 1); cfgForm.dirty = true; renderAddonsGroups();
      };
    });
    wrap.querySelectorAll('[data-grp-additem]').forEach(function (n) {
      n.onclick = function () {
        var gi = +n.dataset.grpAdditem;
        c.groups[gi].items.push({ key: '', variantId: '', label: '', saving: 0,
          savingType: 'fixed', legacyVids: [], preorder: false });
        cfgForm.dirty = true;
        renderAddonsItems(gi);
      };
    });
  }

  /* Recompute one row's "bundle £X" figure in place. A full renderAddonsItems()
     here would rebuild the row mid-keystroke, the Saving input lost focus after
     every character (and partial decimals like "5." were clobbered). */
  function updateItemCalc(inputEl, it) {
    var row = inputEl.closest('.ag-bnd-cfg-item'); if (!row) return;
    var out = row.querySelector('.calc b'); if (!out) return;
    var info = it.variantId ? (cfgForm.addOnInfo[it.variantId] || null) : null;
    var realPrice = info ? Number(info.price) || 0 : 0;
    out.textContent = money(Math.max(0, realPrice - (Number(it.saving) || 0))); // flat off, mirrors renderAddonsItems
  }

  function renderAddonsItems(gi) {
    var box = document.querySelector('[data-grp-items="' + gi + '"]');
    if (!box) return;
    var g = cfgForm.config.groups[gi];
    if (!g.items.length) {
      box.innerHTML = '<div class="ag-bnd-cfg-empty" style="margin:4px 0;">No add-ons in this group yet.</div>';
      return;
    }
    box.innerHTML = g.items.map(function (it, ii) {
      var info = it.variantId ? (cfgForm.addOnInfo[it.variantId] || null) : null;
      var img = info && info.product && info.product.featuredImage && info.product.featuredImage.url;
      var displayTitle = info ? ((info.product && info.product.title || '') +
        (info.title && info.title !== 'Default Title' ? ' \u00b7 ' + info.title : '')) : '';
      var realPrice = info ? Number(info.price) || 0 : 0;
      var bundlePrice = Math.max(0, realPrice - it.saving); // flat £ off only
      var pickedHtml = info
        ? '<div class="ag-bnd-cfg-itemname"><b>' + esc(displayTitle) + '</b>' +
          '<span class="sub">SKU ' + esc(info.sku || '-') + ' · real £' + realPrice.toFixed(2) + '</span></div>'
        : '<div class="ag-bnd-cfg-itemname"><i class="ag-dim">Pick a real variant…</i>' +
          '<input type="text" data-pick="' + gi + '.' + ii + '" placeholder="Search variants…" style="margin-top:4px;"></div>';
      return '<div class="ag-bnd-cfg-item" data-ii="' + ii + '">' +
        (img ? '<img src="' + esc(img) + '">' : '<span class="ag-bnd-thumb"></span>') +
        pickedHtml +
        '<label class="ag-dim" style="font-size:11px;">Saving' +
          '<input type="number" min="0" step="0.01" data-saving="' + gi + '.' + ii + '" value="' + it.saving + '"></label>' +
        '<label class="ag-dim" style="font-size:11px;">Type' +
          '<select data-stype="' + gi + '.' + ii + '"><option value="fixed" selected>£ off</option></select></label>' +
        '<div class="calc">bundle<b>£' + bundlePrice.toFixed(2) + '</b></div>' +
        '<button class="ag-btn ag-btn-danger" data-rmitem="' + gi + '.' + ii + '" type="button">×</button>' +
        '<div class="ag-bnd-cfg-itemextra">' +
          '<label>Label <input type="text" data-label="' + gi + '.' + ii + '" value="' + esc(it.label) + '" placeholder="auto from variant"></label>' +
          '<label>Legacy variant ids (ad-URL compat) <input type="text" class="ag-bnd-cfg-legacy" data-legacy="' + gi + '.' + ii + '" value="' + esc(it.legacyVids.join(', ')) + '" placeholder="comma-separated old duplicate ids"></label>' +
          '<label><input type="checkbox" data-pre="' + gi + '.' + ii + '"' + (it.preorder ? ' checked' : '') + '> Pre-order</label>' +
        '</div>' +
      '</div>';
    }).join('');

    box.querySelectorAll('[data-pick]').forEach(function (n) {
      wireVariantPick(n, function (variantId, info) {
        var pair = n.dataset.pick.split('.'), gj = +pair[0], ij = +pair[1];
        var it = cfgForm.config.groups[gj].items[ij];
        it.variantId = variantId;
        if (!it.label && info && info.title) it.label = info.title;
        cfgForm.addOnInfo[variantId] = info;
        cfgForm.dirty = true;
        renderAddonsItems(gj);
      });
    });
    box.querySelectorAll('[data-saving]').forEach(function (n) {
      n.oninput = function () {
        var p = n.dataset.saving.split('.'), it = cfgForm.config.groups[+p[0]].items[+p[1]];
        it.saving = Number(n.value) || 0; updateItemCalc(n, it);
      };
    });
    box.querySelectorAll('[data-stype]').forEach(function (n) {
      n.onchange = function () {
        var p = n.dataset.stype.split('.'), it = cfgForm.config.groups[+p[0]].items[+p[1]];
        it.savingType = n.value === 'pct' ? 'pct' : 'fixed'; updateItemCalc(n, it);
      };
    });
    box.querySelectorAll('[data-label]').forEach(function (n) {
      n.oninput = function () {
        var p = n.dataset.label.split('.'), it = cfgForm.config.groups[+p[0]].items[+p[1]];
        it.label = n.value;
      };
    });
    box.querySelectorAll('[data-legacy]').forEach(function (n) {
      n.oninput = function () {
        var p = n.dataset.legacy.split('.'), it = cfgForm.config.groups[+p[0]].items[+p[1]];
        it.legacyVids = n.value.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      };
    });
    box.querySelectorAll('[data-pre]').forEach(function (n) {
      n.onchange = function () {
        var p = n.dataset.pre.split('.'), it = cfgForm.config.groups[+p[0]].items[+p[1]];
        it.preorder = n.checked;
      };
    });
    box.querySelectorAll('[data-rmitem]').forEach(function (n) {
      n.onclick = function () {
        var p = n.dataset.rmitem.split('.'), gj = +p[0];
        cfgForm.config.groups[gj].items.splice(+p[1], 1);
        cfgForm.dirty = true;
        renderAddonsItems(gj);
      };
    });
  }

  /* Tiny live-search picker, reuses state.products (one row per VARIANT)
     so the operator picks the exact add-on variant. Calls onPick(vid, info)
     with the matched product+variant info so the row can render
     immediately without a round-trip. */
  function wireVariantPick(inputEl, onPick) {
    var pop = el('<div class="ag-bnd-results" style="position:absolute;background:var(--ag-panel-2);border:1px solid var(--ag-border);border-radius:6px;max-height:240px;overflow:auto;width:340px;z-index:100;"></div>');
    inputEl.parentNode.appendChild(pop);
    // The results dropdown is position:absolute with top:100% (via .ag-bnd-results). Its container
    // (.ag-bnd-cfg-itemname) isn't positioned, so top:100% resolved against the page and the dropdown
    // rendered off-screen at the bottom ("nothing appears" when searching). Anchor it to the input.
    if (inputEl.parentNode && inputEl.parentNode.style) inputEl.parentNode.style.position = 'relative';
    inputEl.oninput = function () {
      var term = inputEl.value.trim().toLowerCase();
      if (!term) { pop.style.display = 'none'; return; }
      if (!state.products) {
        pop.innerHTML = '<div class="ag-bnd-result ag-dim">Loading product list…</div>';
        pop.style.display = ''; return;
      }
      var matches = state.products.filter(function (p) {
        return (p.title && p.title.toLowerCase().indexOf(term) !== -1) ||
               (p.sku && p.sku.toLowerCase().indexOf(term) !== -1);
      }).slice(0, 20);
      pop.innerHTML = matches.length ? matches.map(function (x) {
        return '<div class="ag-bnd-result" data-vid="' + esc(x.variantId) + '">' +
          (x.image ? '<img src="' + esc(x.image) + '">' : '<span class="ag-bnd-thumb"></span>') +
          '<span>' + esc(x.title) + '</span><b>' + money(x.price) + '</b></div>';
      }).join('') : '<div class="ag-bnd-result ag-dim">No matches</div>';
      pop.style.display = '';
      pop.querySelectorAll('[data-vid]').forEach(function (n) {
        n.onclick = function () {
          var vid = n.dataset.vid;
          var picked = state.products.filter(function (p) { return p.variantId === vid; })[0];
          /* Synthesise a minimal addOnInfo entry for the row render. */
          var info = picked ? {
            id: vid, sku: picked.sku, price: picked.price,
            title: splitPickLabel(picked.title).variant,
            product: { title: splitPickLabel(picked.title).product,
              featuredImage: { url: picked.image } }
          } : null;
          pop.style.display = 'none'; inputEl.value = '';
          onPick(vid, info);
        };
      });
    };
    document.addEventListener('click', function onDoc(ev) {
      if (!inputEl || !document.body.contains(inputEl)) {
        document.removeEventListener('click', onDoc); return;
      }
      if (ev.target !== inputEl && !pop.contains(ev.target)) pop.style.display = 'none';
    });
  }

  function saveAddonsForm() {
    if (!cfgForm.baseProductId) { AG_ADMIN.toast('Pick a base first', true); return; }
    var unpicked = 0;
    cfgForm.config.groups.forEach(function (g) { g.items.forEach(function (it) { if (!it.variantId) unpicked++; }); });
    if (unpicked && !confirm(unpicked + ' add-on row(s) have no variant picked yet and will NOT be saved. Save anyway?')) return;
    var btn = $('cfg-save'); btn.disabled = true; btn.textContent = 'Saving…';
    /* Ensure every item has either a variantId (skip silently) or a
       resolved key (auto from label). Drop items without variantId. */
    var clean = { version: cfgForm.config.version || 1, groups: cfgForm.config.groups.map(function (g) {
      return {
        key: g.key || slugify_(g.label),
        label: g.label, required: !!g.required, multi: !!g.multi,
        items: g.items.filter(function (it) { return it.variantId; }).map(function (it) {
          return {
            key: it.key || slugify_(it.label),
            variantId: it.variantId, label: it.label,
            saving: Number(it.saving) || 0,
            savingType: 'fixed', // AGPB add-on savings are flat £ only (pct never honored by theme/checkout)
            legacyVids: it.legacyVids || [], preorder: !!it.preorder
          };
        })
      };
    }) };
    AG_ADMIN.api('ui_cfg_save', { productId: cfgForm.baseProductId, config: clean }).then(function (r) {
      AG_ADMIN.toast('Config saved · ' + (r.addOnsSaved || 0) + ' add-on metafields mirrored');
      cfgForm.dirty = false;
      state.cfgConfigs = null; // bust the list cache
      btn.disabled = false; btn.textContent = 'Save config';
    }).catch(function (e) {
      AG_ADMIN.toast('Save failed: ' + e.message, true);
      btn.disabled = false; btn.textContent = 'Save config';
    });
  }

  function slugify_(s) { return String(s || 'item').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
})();
